import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  DialogContentText,
  DialogTitle,
  IconButton,
  Hidden,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
//import useAutocomplete from "@material-ui/lab/useAutocomplete";

import React from "react";
import GetAppIcon from "@material-ui/icons/GetApp";
import axios from "axios";
import { baseApiURL, apiKeys, user } from "../../Utilities/Utility";
import { tableOptionsAttachment } from "../../Themes/LightTheme";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import debounce from "lodash.debounce";
import { useEffect, useState } from "react";
import {
  BootstrapInput,
  tableIconsInputScreen,
  tableIcons,
} from "../../Utilities/Utility";
import AddLineItemDialog from "./add-line-item-dialog";
import { tableOptionsUser } from "../../Themes/LightTheme";
import MaterialTable from "material-table";
import { useSelector } from "react-redux";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import {
  getInspNumber,
  SaveInspData,
  GetCommodity,
  GetProductMaster,
  GetFinalDecision,
  GetInspectionLineItems,
  GetSuppliers,
  GetSpiridonNo,
  AddAttachmentDetails,
  GetUploadAttachmentsDetail,
  deleteLineItem,
  deleteInspectionAttachments,
  GetFileDetailsBasedOnCommoidty,
  SaveOrUpdatePdirDocumentList,
  GetSelectedPdirDocumentList,
  uploadCommodityFileData,
  GetuploadedAttachments,
  acknowledgeReport,
  AddLineItemDetails,
  rejectReviewerReport,
} from "../../Redux/APIs/api_Pdir";
import Loading from "../../Components/Loader/Loader";
import SnackbarCustom from "../../Components/Snackbar/Snackbar";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { DeleteOutlined } from "@material-ui/icons";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import InputAdornment from "@material-ui/core/InputAdornment";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

export default function AddInspection() {
  const location = useLocation();
  const data = location.state;
  const fromPage = location?.state?.from;
  const navigate = useNavigate();
  const [uploadedRows, setUploadedRows] = useState([]);
  const GetUploadButton = () => <CloudUploadIcon />;
    const inspectionNumberId = location?.state?.inspectionNumberId;
    console.log("inspectionNumberIdfromlocNidhi", inspectionNumberId);
  const [mandatoryDocs,setMandatoryDocs] = useState([]);
  const [supplierList, SetSupplierList] = useState([]);
  const [commodityList, SetCommodityList] = useState([]);
  const [spirdonList, SetSpirdonList] = useState([]);
  const [decisionList, SetDecisionList] = useState([]);
  const [inspData, setInsData] = useState({});
  const [inspectionLineItems, setInspectionLineItems] = useState([]);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [editUser, setEditUser] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadTableData, setUploadTableData] = useState([]);
    const [observationRow, setObservationRow] = useState([]);
    const [inspectionNumberId1, setInspectionNumberId1] = useState();
  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const showFields =
    [1, 2, 6].includes(userDetails.roleId) && fromPage === "/listInspection";
  const [isSampleGenerated, setIsSampleGenerated] = useState(false);
  let [inputFileAttachment, setInputFileAttachment] = useState(Date.now);
  const [dateInputs, setDateInputs] = useState({
    startDate: null,
    endDate: null,
  });
  const [isObservationEdited, setIsObservationEdited] = useState(false);
  const [sampleSize, setSampleSize] = useState("");

  const [formData, setFormData] = useState({
    supplierCode: "",
    supplierId: "",
    supplierName: "",
    commodity: "",
    partId: "",
    partNumber: "",
    partDescription: "",
    product: "",
    productType: "",
    obserVation: "",
    finalDecision: "",
    pono: "",
    workOrdeNo: "",
    lotQuantity: "",
    sampleQuantity: "",
    lotNoBatchNoRouteSheet: "",
    startDate: "",
    endDate: "",
    sampleCode: "",
    sampleSize: "",
    acceptPoint: "",
    rejectPoint: "",
    inspectedBy: "",
    inspectedById: "",
    toBeCheckedBy: "",
    toBeCheckedById: "",
  });

  const [rows, setRows] = useState([]);
  const isEditMode = Boolean(data?.inspectionNumberId);

  const [reviewers, setReviewers] = useState([]);
  console.log("userDetails", userDetails);
  //useEffect(() => {
  //  if (userDetails.supplierId) {
  //    getReviewersDDL(userDetails.supplierId);
  //    }

    //}, [userDetails.supplierId]);//earlier working

    useEffect(() => {
        if (userDetails.supplierId) {
            const fallbackInspectionId =
                inspectionNumberId1 ||
                data?.inspectionNumberId ||
                inspData?.inspectionNoId;

            if (fallbackInspectionId) {
                getReviewersDDL(userDetails.supplierId, fallbackInspectionId);
            }
        }
    }, [userDetails.supplierId, inspectionNumberId1]);

   

    const getReviewersDDL = async (supplierId, inspectionNumberId) => {
    //const inspectionNumberId = data?.inspectionNumberId
    //  ? data.inspectionNumberId
    //  : inspData.inspectionNoId;//earlier working
    try {
      const response = await axios.get(
        `${baseApiURL}/PDIR/GetReviewerEmails?supplierId=${supplierId}&InpectionNumberId=${inspectionNumberId}`,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            userId: UID.id,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
          },
        }
      );

      if (response.data?.result?.response) {
        console.log("reviewersdata", response.data.result.objResult);
        setReviewers(response.data.result.objResult);
      }
    } catch (error) {
      console.error("Error fetching reviewers", error);
    }
  };

  const sampleColumns = Array.from({ length: 10 }, (_, i) => ({
    title: `Sample${i + 1}`,
    render: (rowData) => {
      const sampleValue = rowData.inspectionSamples?.[i]?.sampleData;

      const min = Number(rowData.minValue);
      const max = Number(rowData.maxValue);

      if (
        sampleValue === null ||
        sampleValue === undefined ||
        sampleValue === ""
      ) {
        return "";
      }

      const isValid = sampleValue >= min && sampleValue <= max;

      return (
        <span
          style={{
            color: isValid ? "green" : "red",
            fontWeight: 600,
          }}
        >
          {sampleValue}
        </span>
      );
    },
  }));

  const baseColumns = [
    { title: "Ballooning No.", field: "bnNo", editable: "never" },
    { title: "Specification", field: "specification", editable: "never" },
    { title: "Min", field: "minValue", editable: "never" },
    { title: "Max", field: "maxValue", editable: "never" },
  ];

  const extraColumns = [
    ...sampleColumns,
    { title: "Result", field: "result", editable: "never" },
    { title: "High Dimension", field: "highDimension", editable: "never" },
    { title: "Low Dimension", field: "lowDimension", editable: "never" },
    { title: "Positive Tole", field: "positiveTole", editable: "never" },
    { title: "Negative Tole", field: "negativeTole", editable: "never" },
    { title: "Remark", field: "remarks", editable: "onUpdate" },
    {
      title: "Measuring Instrument",
      field: "measuringInstrument",
      editable: "onUpdate",
    },
    { title: "Measuring Id", field: "measurementID", editable: "onUpdate" },
    { title: "Measuring Unit", field: "measurementUnit", editable: "onUpdate" },
  ];

  // Decide which columns to show
  let columns = [];

  if ([1, 2, 6].includes(userDetails.roleId)) {
    if (fromPage === "/listInspection") {
      // Admin coming from listInspection → addInspection
      columns = [...baseColumns, ...extraColumns];
    } else {
      // Admin create/view page
      columns = [...baseColumns];
    }
  } else if ([3, 12].includes(userDetails.roleId) || showFields) {
    // Supplier or showFields = true
    columns = [...baseColumns, ...extraColumns];
  }

  // commodity file upload

  const [tableDataforFile, setTableDataforFile] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [docuBtnList, setDocuBtnList] = useState([]);

  const columnsUploadData = [
    {
      title: "Upload File List",
      field: "docName",
      render: (rowData) => <span>{rowData.docName}</span>,
      headerStyle: { fontWeight: "bold" },
    },
  ];

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  const handleClose = (e) => {
    setOpen(false);
  };

    const handleEditaddLineItem = (editRowData) => {
        setOpenDialog(true);
        setEditUser(editRowData);
        console.log("rowdata", editRowData);

        //getInspectionLineItems(
        //  data?.inspectionNumberId
        //    ? data.inspectionNumberId
        //    : inspData.inspectionNoId
        //  );earlier
        getInspectionLineItems((isValidStatus1 && inspectionNumberId1)
            ? inspectionNumberId1
            : data?.inspectionNumberId || inspData.inspectionNoId);
    }
  const [openDialogReject, setOpenDialogReject] = useState(false);

  const handleDialogOpenReject = (e) => {
    setOpenDialogReject(true);
  };
  const handleCloseReject = (e) => {
    setOpenDialogReject(false);
  };

  const [rejectRemarkBySupplier, setRejectRemarkBySupplier] = useState("");
  const getRejectRemarkBySupplier = (e) => {
    setRejectRemarkBySupplier(e.target.value);
    };


    


  useEffect(() => {
    getInspectionNumber();
  }, []);

  useEffect(() => {
    if (formData.commodity) {
      getFileListbasedonCommodity(formData.commodity);
    }
  }, [formData.commodity]);

   
 useEffect(() => { 

        const init = async () => {
            console.log("Received Data:", data);

            if (data) {
                getUploadTableData(
                    data?.inspectionNumberId
                        ? data.inspectionNumberId
                        : inspData.inspectionNoId
                );
                getInspectionLineItems(
                    data?.inspectionNumberId
                        ? data.inspectionNumberId
                        : inspData.inspectionNoId
                );
            }

            if (data) {
                setDateInputs({
                    startDate: data.startDate?.slice(0, 10) || "",
                    endDate: data.endDate?.slice(0, 10) || "",
                });



                const normalize = (str) => str?.trim().toLowerCase();

                const status = normalize(data?.statusName);

                const shouldClear = 
                    userDetails.roleId === 3 &&
                   ( status === "approved" ||
                    status === "updated by supplier,pending at iqc engineer for approval" ||
                    status === "acknowledged by iqc engineer")

                setFormData((prev) => ({
                    ...prev,
                    supplierCode: data.supplierCode || "",
                    supplierId: data.supplierId || "",
                    supplierName: data.supplierName || "",
                    commodity: data.commodityId || "",
                    partId: data.partId || "",
                    partNumber: data.partNo || "",
                    partDescription: data.description || "",
                    product: data.product || "",
                    productType: data.productType || "",
                    obserVation: data.observation || "",
                    finalDecision: data.finalDecisionId || "",
                    pono: data.pono ?? "",
                    workOrdeNo: data.workOrdeNo || "",

                    lotQuantity: shouldClear ? "" : data.lotQuantity,

                    lotNoBatchNoRouteSheet: shouldClear ? "" : data.lotNoBatchNoRouteSheet,

                    // lotQuantity: data.statusName == "Approved" || "Updated by Supplier,Pending at IQC Engineer for Approval" || "Acknowledged by IQC Engineer" || "Rejected by IQC Engineer,Sent back to Supplier" ? "" : data.lotQuantity,//earlier

                    sampleQuantity: data.sampleQuantity || "",
                    // lotNoBatchNoRouteSheet: data.statusName == "Approved" || "Updated by Supplier,Pending at IQC Engineer for Approval" || "Acknowledged by IQC Engineer" || "Rejected by IQC Engineer,Sent back to Supplier" ? "" : data.lotNoBatchNoRouteSheet,//earlier
                    startDate: data.startDate?.slice(0, 10) || "",
                    endDate: data.endDate?.slice(0, 10) || "",
                    sampleCode: data.sampleCode || "",
                    sampleSize: data.sampleSize || "",
                    acceptPoint: data.acceptPoint || "",
                    rejectPoint: data.rejectPoint || "",
                    inspectedBy: userDetails.roleId === 3
                        ? (data?.inspectedByEmail || userDetails.userEmail)
                        : "",

                    inspectedById: userDetails.roleId === 3
                        ? (data?.inspectedBy || userDetails.userId)
                        : "",

                    toBeCheckedBy: userDetails.roleId === 3 ? (data?.toBeCheckedByEmail || "") : "",

                    toBeCheckedById: userDetails.roleId === 3 ? (data?.toBeCheckedBy || "") : "",
                }));

                getFileListbasedonCommodity(data.commodityId);
            }

            getCommodity();

            getFinalDecision();



            if (formData?.supplierId) {
                GetSuppliers(
                    siteToken.token,
                    azureToken.token,
                    UID.id,
                    userDetails.userEmail,
                    userDetails.gid,
                    userDetails.role,
                    userDetails.roleId,
                    formData.supplierName || "" // search by name
                ).then((data) => {
                    console.log("data", data);
                    SetSupplierList(data || []);
                });
            }

            if (formData?.partId) {
                GetSpiridonNo(
                    siteToken.token,
                    azureToken.token,
                    UID.id,
                    userDetails.userEmail,
                    userDetails.gid,
                    userDetails.role,
                    userDetails.roleId,
                    formData.partNumber || "" // search by name
                ).then((data) => {
                    SetSpirdonList(data || []);
                });
            }
            
        }
        init();
 }, [data, formData?.supplierId, formData?.partId]);

    //data, formData.supplierId, formData.partNumber

  useEffect(() => {
    if (
      formData.commodity &&
      commodityList.length > 0 &&
      !isObservationEdited &&
      !data?.observation
    ) {
      const selectedItem = commodityList.find(
        (item) => item.commodityId === Number(formData.commodity)
      );

      setFormData((prev) => ({
        ...prev,
        obserVation: selectedItem?.observations || "",
      }));
    }
  }, [formData.commodity, commodityList, isObservationEdited, data]);




    useEffect(() => {
        const normalize = (str) => str?.trim().toLowerCase();

        const status = normalize(data?.statusName);

        const isValidStatus =
            userDetails.roleId === 3 && (
                (data?.statusId === 3 &&
                    status ===
                    "updated by supplier,pending at iqc engineer for approval") ||

                (data?.statusId === 6 &&
                    status === "acknowledged by iqc engineer") ||

                (data?.statusId === 4 &&
                    status === "approved")
            );

        console.log("RoleId:", userDetails.roleId);
        console.log("Status:", data?.statusName);
        console.log("Should Reset:", isValidStatus);

        if (isValidStatus) {
            setFormData((prev) => ({
                ...prev,
                lotNoBatchNoRouteSheet: "",
                lotQuantity: ""
            }));
        }
    }, [data?.statusId, data?.statusName, userDetails.roleId]);



    //useEffect(() => {
    //    const normalize = (str) => str?.trim().toLowerCase();

    //    const isValidStatus =
    //        (data?.statusId === 3 && userDetails.roleId==3 && 
    //            normalize(data?.statusName) ===
    //            "updated by supplier,pending at iqc engineer for approval") ||
    //        (data?.statusId === 6 &&
    //            normalize(data?.statusName) ===
    //            "acknowledged by iqc engineer") ||
    //        (data?.statusId === 4 &&
    //            normalize(data?.statusName) === "approved");

    //    console.log("Current Status:", data?.statusName);
    //    console.log("Should Reset:", isValidStatus);

    //    if (isValidStatus) {
    //        console.log(" Clearing fields...");
    //        setFormData((prev) => ({
    //            ...prev,
    //            lotNoBatchNoRouteSheet: "",
    //            lotQuantity: ""
    //        }));
    //    } else {
    //        console.log(" No clearing");
    //    }
    //}, [data?.statusId, data?.statusName]);working without roleid






    //useEffect(() => {
    //    if (data && data.statusId === 4 && data.statusName == "Approved") {
    //            setFormData(prev => ({
    //                ...prev,
    //                lotNoBatchNoRouteSheet: "",
    //                lotQuantity: ""
    //            }));
    //        }//earlier

    //}, [data])

    //useEffect(() => {
    //    if (data && data.statusId === 3 && data.statusName == "Updated by Supplier,Pending at IQC Engineer for Approval") {
    //        setFormData(prev => ({
    //            ...prev,
    //            lotNoBatchNoRouteSheet: "",
    //            lotQuantity: ""
    //        }));
    //    }//earlier

    //}, [data])

    //useEffect(() => {
    //    if (data && data.statusId === 6 && data.statusName == "Acknowledged by IQC Engineer") {
    //        setFormData(prev => ({
    //            ...prev,
    //            lotNoBatchNoRouteSheet: "",
    //            lotQuantity: ""
    //        }));
    //    }//earlier

    //}, [data])

    //useEffect(() => {
    //    if (data && data.statusId === 5 && data.statusName == "Rejected by IQC Engineer,Sent back to Supplier") {
    //        setFormData(prev => ({
    //            ...prev,
    //            lotNoBatchNoRouteSheet: "",
    //            lotQuantity: ""
    //        }));
    //    }//earlier

    //}, [data])


    //useEffect(() => {
    //    //if (data && data.statusId === 4 && data.statusName == "Approved") {
    //    //    setFormData(prev => ({
    //    //        ...prev,
    //    //        lotNoBatchNoRouteSheet: "",
    //    //        lotQuantity: ""
    //    //    }));
    //    //}//earlier

    //    if ((data && (data?.statusId == 4 && data?.statusName === "Approved") ||
    //        (data?.statusId == 3 && data?.statusName === "Updated by Supplier,Pending at IQC Engineer for Approval") ||
    //        (data?.statusId == 6 && data?.statusName === "Acknowledged by IQC Engineer") ||
    //        (data?.statusId == 5 && data?.statusName === "Rejected by IQC Engineer,Sent back to Supplier"))) {
    //        setFormData(prev => ({
    //            ...prev,
    //            lotNoBatchNoRouteSheet: "",
    //            lotQuantity: ""
    //        }));
    //        }
    //}, [data]);


    //useEffect(() => {
    //    const validStatuses = [
    //        { id: 4, name: "Approved" },
    //        { id: 3, name: "Updated by Supplier,Pending at IQC Engineer for Approval" },
    //        { id: 6, name: "Acknowledged by IQC Engineer" },
    //        { id: 5, name: "Rejected by IQC Engineer,Sent back to Supplier" }
    //    ];

    //    const isValidStatus = validStatuses.some(
    //        s => data?.statusId == s.id && data?.statusName === s.name
    //    );

    //    if (data && isValidStatus) {
    //        setFormData(prev => ({
    //            ...prev,
    //            lotNoBatchNoRouteSheet: "",
    //            lotQuantity: ""
    //        }));
    //    }
    //}, [data]);



  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,

      ...(name === "lotQuantity" && {
        sampleSize: "",
        sampleCode: "",
        acceptPoint: "",
        rejectPoint: "",
      }),
    }));
    };

    const normalize1 = (str) => str?.trim().toLowerCase();

    const isValidStatus2 =
        (data?.statusId === 3 &&
            normalize1(data?.statusName) ===
            "updated by supplier,pending at iqc engineer for approval") ||
        (data?.statusId === 6 &&
            normalize1(data?.statusName) ===
            "acknowledged by iqc engineer") ||
        (data?.statusId === 4 &&
            normalize1(data?.statusName) === "approved") ||
        (data?.statusId === 1 &&
            normalize1(data?.statusName) === "submitted by siemens engineer and pending with supplier");
    //for approved and more 3 status validation this is added

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.supplierId) {
      handleSnackOpen("Supplier is mandatory", "error");
      return;
    }
    if (!formData.commodity) {
      handleSnackOpen("Commodity is mandatory", "error");
      return;
    }

    if (!formData.partId) {
      handleSnackOpen("Part no is mandatory", "error");
      return;
      }


      if (isValidStatus2 && !formData.lotNoBatchNoRouteSheet ) {
          handleSnackOpen("Please enter Batch Number", "error");
          return;
      }

      if (isValidStatus2 && !formData.lotQuantity) {
          handleSnackOpen("Please enter Lot Quantity", "error");
          return;
      }

    const po = String(formData.pono ?? "").trim();

    if (userDetails.roleId === 3 && !/^\d{10}$/.test(po)) {
      handleSnackOpen("PO number must be exactly 10 digits", "error");
      return;
    }

    if (!data && !uploadTableData?.length) {
      handleSnackOpen("Please upload document before submitting", "error");
      return;
    }

    if (
      userDetails.roleId === 3 &&
      !data?.toBeCheckedBy &&
      !formData.toBeCheckedById
    ) {
      handleSnackOpen("To be checked by is mandatory", "error");
      return;
    }

    if (userDetails.roleId === 3) {
      const missingMandatoryDoc = docuBtnList.find(
        (item) => item.isMandatory && !item.fileName // uploaded file ka reference
      );

      if (missingMandatoryDoc) {
        handleSnackOpen(
          `Please upload "${missingMandatoryDoc.documentName}" before submitting`,
          "error"
        );
        return; // stop submit
      }
     }
     // console.log("inspectionNumberId1", inspectionNumberId1);
      //InspectionNumberId--need to send in post api
    //return;
    console.log("form", formData);
    let input = {};
    //input.InspectionNumberId = data?.inspectionNumberId
    //    ? data.inspectionNumberId : (data?.statusId == 4 && data?.statusName == "Approved") ? inspectionNumberId1
    //          : inspData.inspectionNoId || null;// data?.statusId === 4 && data?.statusName == "Approved"?inspectionNumberId1


      input.InspectionNumberId =
          (isValidStatus1 && inspectionNumberId1 )
              ? inspectionNumberId1
              : data?.inspectionNumberId || inspData.inspectionNoId;
    input.InspectionNumber = data?.inspectionNumber
      ? data.inspectionNumber
          : inspData.inspectionNumber || null;
      // inspectionNumber need to send
    input.SupplierId = formData.supplierId || null;
    input.CommodityId = formData.commodity || null;
    input.Observation = formData.obserVation || null;
    input.PartId = formData.partId || null;
    input.ProductTypeId = formData.productMasterId || null;
    input.FinalDecisionId = formData.finalDecision || null;
    input.CreatedBy = userDetails.userId || null;
    input.ProductType = formData.productType || null;
    // input.InspectedBy = formData.inspectedById || null;
    // input.ToBeCheckedBy = formData.toBeCheckedById || null;
    input.InspectedBy = userDetails.roleId === 3 ? (formData.inspectedById || null) : null;
    input.ToBeCheckedBy = userDetails.roleId === 3 ? (formData.toBeCheckedById || null) : null;

    if (data) {
      input.Pono = formData.pono || 0;
      input.WorkOrdeNo = formData.workOrdeNo || null;
      input.LotQuantity = formData.lotQuantity || null;
      input.SampleQuantity = formData.sampleQuantity || null;
      input.LotNoBatchNoRouteSheet = formData.lotNoBatchNoRouteSheet || null;
      input.StartDate = dateInputs.startDate || null;
      input.EndDate = dateInputs.endDate || null;
      //input.ModifiedBy = userDetails.userId || null;
    }
    console.log("input", input);

    setIsLoader(true);
    SaveInspData(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      input
    )
      .then((response) => {
        if (response.response == true) {
          handleSnackOpen(response.responseMsg || "", "success");
          setIsObservationEdited(false);
          if (response.objResult?.observation) {
            setFormData((prev) => ({
              ...prev,
              obserVation: response.objResult.observation,
            }));
          }
          setTimeout(() => {
            if ([1, 2, 6, 3].includes(userDetails.roleId)) {
              navigate("/viewInspection");
            }
          }, 3000);
        }

        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  function handleBack() {
    if (showFields) {
      navigate("/listInspection");
      return;
    }
    if ([1, 2, 6, 3].includes(userDetails.roleId)) {
      navigate("/viewInspection");
    } else if (userDetails.roleId == 12) {
      navigate("/listInspection");
    }
  }

  const handleAdd = () => {
    setEditUser(false);
    setOpenDialog(true);
  };

  function getInspectionNumber() {
    getInspNumber(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
        .then((response) => {
            console.log("inspData", response);
        setInsData(response.objResult);
        getInspectionLineItems(
          data?.inspectionNumberId
            ? data.inspectionNumberId
            : inspData.inspectionNoId
        );
        console.log("res", response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function getCommodity() {
    GetCommodity(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        SetCommodityList(response.objResult);
        console.log("commodity", response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function getFinalDecision() {
    GetFinalDecision(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        SetDecisionList(response.objResult);

        console.log("Final decision", response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function getInspectionLineItems(inspectionNoId) {
    GetInspectionLineItems(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      inspectionNoId
    )
        .then((response) => {
            console.log("dimensionsdata", response);
          setRows(response.objResult);
          //if (data.statusName == "Approved" && data.statusId == 4) {
          //    setRows([]);
            //}
            let dataRows = response.objResult || [];
            dataRows = cleanSampleDataIfApproved(dataRows);


            const formattedRows = dataRows.map((item) => ({
                ...item,
                measurementUnit:
                    item.measurementUnit ??
                    item.measuringUnit ??
                    "",
            }));


            setRows(formattedRows);//added later for measuring unit id issue check
           // setRows(dataRows)//earlier for grid clean

        console.log("InspectionLineitems", response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleSelectChange = (e) => {
    console.log("Select changed", e.target.value);
    const selectedId = e.target.value;

    const selectedItem = commodityList.find(
      (item) => item.commodityId === selectedId
    );

    setFormData({
      ...formData,
      commodity: selectedId,
      obserVation: selectedItem ? selectedItem.observations : "",
    });
  };

  const closeLineItem = () => {
    setOpenDialog(false);
    getInspectionLineItems(
      data?.inspectionNumberId
        ? data.inspectionNumberId
        : inspData.inspectionNoId
    );
  };

  function GetEditButton() {
    return (
      <Tooltip title="Edit" placement="bottom">
        <span>
          <Button href="javascript:void(0)">
            <span>
              <EditOutlinedIcon fontSize="small" className="attachFileIcon" />
            </span>
          </Button>
        </span>
      </Tooltip>
    );
  }

  function GetDeleteButton() {
    return (
      <Tooltip title="Delete" placement="bottom">
        <span>
          <Button href="javascript:void(0)">
            <span>
              <DeleteOutlined fontSize="small" className="attachFileIcon" />
            </span>
          </Button>
        </span>
      </Tooltip>
    );
  }

  function GetDownLoadButton() {
    return (
      // <Tooltip title="Download Sample Excel" placement="bottom">
      <span>
        <Button href="javascript:void(0)">
          <span>
            <GetAppIcon fontSize="small" className="attachFileIcon" />
          </span>
        </Button>
      </span>
      //</Tooltip>
    );
  }

  const UploadAction = ({ onFileSelect }) => {
    return (
      <label style={{ cursor: "pointer", display: "flex" }}>
        <input
          type="file"
          accept=".xls,.xlsx"
          style={{ display: "none" }}
          onChange={(e) => {
            onFileSelect(e.target.files[0]);
            e.target.value = null; // same file reselect fix
          }}
        />
        <GetUploadButton />
      </label>
    );
  };

  const handleDeleteIconClick = (rowData) => {
    setDeleteRowData(rowData);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteRowData(null);
  };

  const handleDialogRowDelete = () => {
    setIsLoader(true);
    setDeleteDialogOpen(false);
    const deleteArgs = deleteRowData.lineItemId;
    console.log("deletedata", deleteArgs);
    deleteLineItem(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      deleteArgs
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getInspectionLineItems(
            data?.inspectionNumberId
              ? data.inspectionNumberId
              : inspData.inspectionNoId
          );
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  const fetchSuppliers = debounce((value, callback) => {
    if (value.length >= 3) {
      GetSuppliers(
        siteToken.token,
        azureToken.token,
        UID.id,
        userDetails.userEmail,
        userDetails.gid,
        userDetails.role,
        userDetails.roleId,
        value
      ).then((data) => {
        console.log("data autocomplete supplier", data);
        callback(data || []);
      });
    }
  }, 400);

  const fetchSpiridon = debounce((value, callback) => {
    if (value.length >= 3) {
      GetSpiridonNo(
        siteToken.token,
        azureToken.token,
        UID.id,
        userDetails.userEmail,
        userDetails.gid,
        userDetails.role,
        userDetails.roleId,
        value
      ).then((data) => {
        console.log("data autocomplete spiridon", data);
        callback(data || []);
      });
    }
  }, 400);

  var columns1 = [
    {
      title: "Attachment",
      field: "fileName",
      editComponent: (props) => getAttachmentComponent(props),
    },
    userDetails.roleId === 3 || userDetails.roleId === 1
      ? {
          title: "Download",
          field: "download",
          editable: "never",
          render: (rowData) => <DownloadFileBtn data={rowData} />,
        }
      : {},
  ];

  var columns2 = [
    {
      title: "Other Observation",
      field: "observation",
      editable: () => [1, 2, 6].includes(Number(userDetails.roleId)),
    },

    {
      title: "Supplier Comment",
      field: "response",
      editable: () => Number(userDetails.roleId) === 3,
    },
  ];

  function DownloadFileBtn({ data }) {
    return (
      <Button
        className="pt-button--tertiary"
        variant="contained"
        onClick={() => downloadFileAttachment(data)}
      >
        Download
      </Button>
    );
  }

  function downloadFileAttachment(data) {
    const attachmentData = {
      FileUrl: data.fileUrl.trim(),
        FileName: data.fileName.trim(),
     
    };

    console.log("Sending data to API:", attachmentData);

    axios
      .post(baseApiURL + "/PDIR/downloadPdirFile", attachmentData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + siteToken.token,
          AzureToken: azureToken.token,
          UserEmail: userDetails.userEmail,
          RoleName: userDetails.role,
          Gid: userDetails.gid,
          Roleid: userDetails.roleId,
              userId: UID.id,

        },
        responseType: "blob", //
      })
      .then((res) => {
        if (!res.data || res.data.size === 0) {
          console.error("Empty file blob received");
          alert("Failed to download PDF (Empty response)");
          return;
        }

        const fileBlob = new Blob([res.data]);
        const downloadUrl = window.URL.createObjectURL(fileBlob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = data.fileName || "downloaded_file";

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch((err) => {
        console.error("DOWNLOAD ERROR:", err);
        alert("Failed to download pdf");
      });
  }

  function handleRowAdd(newTableData, resolve, reject) {
    if (!selectedFile) {
      handleSnackOpen("Please Select a File", "info");
      return reject();
    }
    if (uploadTableData && uploadTableData.length + selectedFile.length > 8) {
      handleSnackOpen("You can upload a maximum of 8 files only.", "warning");
      setIsLoader(false);
      reject();
      return;
    } else {
      setIsLoader(true);

      const formData = new FormData();

      // Correct Key: “file”
      for (let i = 0; i < selectedFile.length; i++) {
        formData.append("File", selectedFile[i]);
      }

      //formData.append(
      //  "InspectionNumber",
      //    (data?.statusId == 4 && data?.statusName === "Approved" && inspectionNumberId1)
      //        ? inspectionNumberId1 : data?.inspectionNumber
      //            ? data.inspectionNumber
      //            : inspData.inspectionNumber
        //);
        formData.append("InspectionNumber",
            (isValidStatus1 && inspectionNumberId1)
                ? inspectionNumberId1
                : data?.inspectionNumberId || inspData.inspectionNoId);

      // DocumentUploadedArea Logic
      let DocumentUploadedArea = null;

      if (userDetails.roleId === 3) {
        DocumentUploadedArea = 2;
      } else if ([1, 2, 6].includes(userDetails.roleId)) {
        DocumentUploadedArea = 1;
      } else {
        handleSnackOpen("Invalid role for DocumentUploadedArea", "error");
        setIsLoader(false);
        return reject();
      }

      formData.append("DocumentUploadedArea", DocumentUploadedArea);
      setIsLoader(false);
      AddAttachmentDetails(
        siteToken.token,
        azureToken.token,
        UID.id,
        userDetails.userEmail,
        userDetails.gid,
        userDetails.role,
        userDetails.roleId,
        formData
      )
        .then((response) => {
          //setIsLoader(false);

          if (response.response) {
            handleSnackOpen("File uploaded successfully", "success");
            setUploadedFileName("");
            setSelectedFile(null);
            resolve();
            setIsLoader(false);
            getUploadTableData(
              data?.inspectionNumberId
                ? data.inspectionNumberId
                : inspData.inspectionNoId
            );
          } else {
            handleSnackOpen(response.responseMsg, "error");
            reject();
            setIsLoader(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoader(false);
          setSelectedFile(null);
          setInputFileAttachment(Date.now());
          handleSnackOpen("Exception: " + error, "error");
          reject();
        });
    }
  }

  function getUploadTableData(InspectionNumberId) {
    setIsLoader(true);

    let uploadedSpace = null;

    if ([1, 2, 6, 12, 3].includes(userDetails.roleId)) {
      uploadedSpace = 1; // Drawings by Siemens
    }

    GetUploadAttachmentsDetail(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      InspectionNumberId,
      uploadedSpace
    )
      .then((response) => {
        const objResult = response?.objResult || [];

        setUploadTableData(objResult);
        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  const updateExcelHandler = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    const fileType = file.type; //  "application/pdf"

    if (fileType !== "application/pdf" && !fileName.endsWith(".pdf")) {
      handleSnackOpen("Only PDF files are allowed", "info");
      event.target.value = null; // file input reset
      return;
    }

    //  if pdf then only save in state
    setSelectedFile(event.target.files);
    setUploadedFileName(file.name);
  };

  function getAttachmentComponent(objProps) {
    return (
      <form className="bulk-upload-form">
        {selectedFile == null ? (
          <>
            <TextField
              id="fileUploadAttachment"
              variant="filled"
              label="Attachment Upload"
              fullWidth
                        onChange={updateExcelHandler}
                        disabled={ userDetails.roleId == 3 || userDetails.roleId == 12}
              key={inputFileAttachment}
              type="file"
              InputLabelProps={{ shrink: true }}
              inputProps={{ multiple: true }}
              helperText={uploadedFileName}
            />
          </>
        ) : (
          <>
            <span>{uploadedFileName}</span>
          </>
        )}
      </form>
    );
  }

  function handleRowDelete(oldFormData, resolve, reject) {
    console.log("oldFormdata", oldFormData.attachmentId);

    let attachmentId = oldFormData.attachmentId;
    setIsLoader(true);
    deleteInspectionAttachments(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      attachmentId
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          resolve();
          setIsLoader(false);
          getUploadTableData(
            data?.inspectionNumberId
              ? data.inspectionNumberId
              : inspData.inspectionNoId
          );
        } else {
          handleSnackOpen(response.responseMsg, "error");
          reject();
          setIsLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
        handleSnackOpen("Exception : " + error, "error");
        reject();
      });
  }

  function handleDateChange(event) {
    const { name, value } = event.target;
    setDateInputs({
      ...dateInputs,
      [name]: value,
    });
  }

  function getFileListbasedonCommodity(comId) {
    setIsLoader(true);
    GetFileDetailsBasedOnCommoidty(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      comId
    )
      .then((response) => {
        const objResult = response?.objResult || [];
        setTableDataforFile(objResult);
        setIsLoader(false);
        getuploadedAttachments( data?.inspectionNumberId
          ? data.inspectionNumberId
          : inspData.inspectionNoId, 5, objResult);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }
  const [data2, setData2] = useState([]);
  function getuploadedAttachments(inspId, uploadedSpace, tabData) {
    setIsLoader(true);
    GetuploadedAttachments(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      inspId,
      uploadedSpace
    )
      .then((response) => {
        const objResult = response?.objResult || [];
        console.log("test", objResult);
        let selectedDoc = [];
        for (let i = 0; i < tabData.length; i++) {
          for (let j = 0; j < objResult.length; j++) {
            if (tabData[i].docId == objResult[j].documentId) {
              tabData[i].tableData.checked = true;
              tabData[i].fileName = objResult[j].fileName;
              tabData[i].fileUrl = objResult[j].fileUrl;
              selectedDoc.push(tabData[i]);
            }
          }
        }
        setData2(objResult);
        getSelectedPdirDocumentList(tabData);
        console.log("selectedDoc", selectedDoc);
        setSelectedRows(selectedDoc);
        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
    }


    //const cleanSampleDataIfApproved = (rowsData) => {
    //    if (
    //        Number(data?.statusId) === 4 &&
    //        data?.statusName?.toLowerCase() === "approved" &&
    //        !inspectionNumberId1
    //    ) {
    //        return rowsData.map((row) => ({
    //            ...row,

    //           //only cleaning samples
    //            sample1: "",
    //            sample2: "",
    //            sample3: "",
    //            sample4: "",
    //            sample5: "",
    //            sample6: "",
    //            sample7: "",
    //            sample8: "",
    //            sample9: "",
    //            sample10: "",
    //        }));
    //    }

    //    return rowsData; // no change
    //};//earlier for approved


    const cleanSampleDataIfApproved = (rowsData) => {
        const validStatuses = [
            { id: 4, name: "approved" },
            { id: 3, name: "updated by supplier,pending at iqc engineer for approval" },
            { id: 6, name: "acknowledged by iqc engineer" }
           
        ];

        const isValidStatus = validStatuses.some(
            (status) =>
                Number(data?.statusId) === status.id &&
                data?.statusName?.toLowerCase() === status.name
        );

        if (isValidStatus && !inspectionNumberId1) {
            return rowsData.map((row) => ({
                ...row,
                sample1: "",
                sample2: "",
                sample3: "",
                sample4: "",
                sample5: "",
                sample6: "",
                sample7: "",
                sample8: "",
                sample9: "",
                sample10: "",
            }));
        }

        return rowsData;
    };
   



  function handleFileUploadList() {
    console.log("selected", selectedRows);
    let doc = [];

    console.log("tableDataforFile", tableDataforFile);
    const docIdset = new Set(selectedRows.map((item) => item.docId));
    const newArray = tableDataforFile.map((item) => ({
        DocumentId: item.docId,
        // inspectionNumberId: (data?.statusId == 4 && data?.statusName === "Approved" && inspectionNumberId1)
        //  ? inspectionNumberId1 : null,
        inspectionNumberId :
         (isValidStatus1 && inspectionNumberId1)
              ? inspectionNumberId1
              : data?.inspectionNumberId || inspData.inspectionNoId || null,
 

        Pdirnumber: data?.inspectionNumber
        ? data.inspectionNumber
        : inspData.inspectionNumber,
      //pdirnumber: data?.inspectionnumber
      //  ? data.inspectionnumber
      //    : inspdata.inspectionnumber,//earlier

      docDetailId:
        docuBtnList.find((x) => x.documentId == item.docId)?.docDetailId || 0,
      IsMandatory: docIdset.has(item.docId) ? true : false,
    }));
    console.log("newArray", newArray);
    console.log("docIdset", docIdset);

    setIsLoader(true);
    SaveOrUpdatePdirDocumentList(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      newArray
    )
      .then((response) => {
        getSelectedPdirDocumentList([...tableDataforFile]);
        handleSnackOpen(response.responseMsg, "success");

        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  function getSelectedPdirDocumentList(tabData) {
    setIsLoader(true);
    // const insp = data?.inspectionNumber
    //   ? data.inspectionNumber
    //   : inspData.inspectionNumber;
   const insp =  (isValidStatus1 && inspectionNumberId1)
              ? inspectionNumberId1
              : data?.inspectionNumberId || inspData.inspectionNoId;
    GetSelectedPdirDocumentList(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      insp
    )
      .then((response) => {
        const objResult = response || [];

        for (let i = 0; i < objResult.length; i++) {
          for (let j = 0; j < tabData.length; j++) {
            if (tabData[j]?.docId == objResult[i]?.documentId) {
              objResult[i].fileName = tabData[j].fileName;
              objResult[i].fileUrl = tabData[j].fileUrl;
            }
          }
        }
        console.log("11", objResult);

        const mandatoryResult = objResult.filter(
          (item, index, self) => item.isMandatory == true
        );
       
        console.log("mandatoryResult", mandatoryResult);

        const adminMandatoryDocs = objResult
          .filter(
            (item) =>
              item.isMandatory &&
              ["Admin", "SQM Engineer Siemens", "Component Engineer (CE)"].includes(item.roleName)
          )
          .map((item) => Number(item.documentId));
        console.log('adminMandatoryDocs', adminMandatoryDocs)
        setMandatoryDocs(adminMandatoryDocs)
        setDocuBtnList(mandatoryResult);
        const updatedTable = tabData.map((row) => {
          const isMandatory = mandatoryResult.some(
            (m) => Number(m.documentId) === Number(row.docId)
          );

          return {
            ...row,
            tableData: {
              ...row.tableData,
              checked: isMandatory,
            },
          };
        });
        setTableDataforFile(updatedTable);
        setSelectedRows(updatedTable.filter((r) => r.tableData.checked));

        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  const [files, setFiles] = useState([]);

  // const handleCommodityfileUpload = (e, name) => {
  //   const inp = {
  //     name: name,
  //     file: e.target.files[0],
  //   };

  //   setFiles((prev) => [...prev, inp]);
  //   console.log("fies", files);
  // };

  const handleCommodityfileUpload = (e, name) => {
  const file = e.target.files[0];
  if (!file) return;

  const isPdf =
    file.type === "application/pdf" ||
    file.name.toLowerCase().endsWith(".pdf");

  if (!isPdf) {
    handleSnackOpen("Only PDF files are allowed", "error");
    e.target.value = null;

    //  sirf isi field ki file remove ki hai 
    setFiles((prev) => prev.filter((f) => f.name !== name));
    return;
  }

  const inp = {
    name: name,
    file: file,
  };

  //  replace existing file (same name)
  setFiles((prev) => {
    const filtered = prev.filter((f) => f.name !== name);
    return [...filtered, inp];
  });
};

  // const handleUploadFileData = (e) => {

  //   let fileData = new FormData();

  //   const insp = data?.inspectionNumber
  //     ? data.inspectionNumber
  //     : inspData.inspectionNumber;

  //   if (!files || files.length === 0) {
  //     handleSnackOpen("Please Upload the files", "error");
  //     return;
  //   }


  //   const invalidFiles = files.filter((item) => {
  //     const f = item.file || item;
  //     if (!f) return true;

  //     const isPdf =
  //       f.type === "application/pdf" ||
  //       f.name.toLowerCase().endsWith(".pdf");

  //     return !isPdf;
  //   });

  //   if (invalidFiles.length > 0) {
  //     handleSnackOpen("Only PDF files are allowed", "error");

  //     setFiles([]);
  //     setUploadedFileName("");
  //     return;
  //   }



  //   fileData.append("userId", userDetails.userId);
  //   fileData.append("InspectionNumber", insp);

  //   files.forEach((element) => {
  //     const f = element.file || element;
  //     fileData.append(element.name || f.name, f);
  //   });

  //   setIsLoader(true);

  //   uploadCommodityFileData(
  //     siteToken.token,
  //     azureToken.token,
  //     UID.id,
  //     userDetails.userEmail,
  //     userDetails.gid,
  //     userDetails.role,
  //     userDetails.roleId,
  //     fileData
  //   )
  //     .then((response) => {
  //       console.log("response", response);
  //       const inspectionId = data?.inspectionNumberId ?? inspData?.inspectionNoId;

  //       if (!inspectionId) {
  //         handleSnackOpen("Inspection ID missing", "error");
  //         return;
  //       }

  //       getuploadedAttachments(inspectionId, 5, tableDataforFile);
  //       //getuploadedAttachments(data.inspectionNumberId, 5, tableDataforFile);
  //       handleSnackOpen(response.responseMsg, "success");

  //       setFiles([]);
  //       setIsLoader(false);
  //     })
  //     .catch((error) => {
  //       handleSnackOpen("Error : " + error, "error");
  //       setIsLoader(false);
  //     });
  // };
  const handleUploadFileData = (e) => {
  let fileData = new FormData();

  // const insp =
  //   data?.inspectionNumber ?? inspData?.inspectionNumber;
    const insp =  (isValidStatus1 && inspectionNumberId1)
              ? inspectionNumberId1
              : data?.inspectionNumberId || inspData.inspectionNoId;

  //  empty check
  if (!files || files.length === 0) {
    handleSnackOpen("Please Upload the files", "error");
    return;
  }

  //  safety validation (extra layer)
  const invalidFiles = files.filter((item) => {
    const f = item.file;
    if (!f) return true;

    return !(
      f.type === "application/pdf" ||
      f.name.toLowerCase().endsWith(".pdf")
    );
  });

  if (invalidFiles.length > 0) {
    handleSnackOpen("Only PDF files are allowed", "error");
    return;
  }

  //  append data
  fileData.append("userId", userDetails.userId);
  fileData.append("InspectionNumber", insp);
 
  files.forEach((element) => {
    fileData.append(element.name, element.file);
  });

  setIsLoader(true);

  uploadCommodityFileData(
    siteToken.token,
    azureToken.token,
    UID.id,
    userDetails.userEmail,
    userDetails.gid,
    userDetails.role,
    userDetails.roleId,
    fileData
  )
    .then((response) => {
      console.log("response", response);

      // FIXED ID 
      // const inspectionId =
      //   data?.inspectionNumberId ?? inspData?.inspectionNoId;
          const insp =  (isValidStatus1 && inspectionNumberId1)
              ? inspectionNumberId1
              : data?.inspectionNumberId || inspData.inspectionNoId;
        

      if (!insp) {
        handleSnackOpen("Inspection ID missing", "error");
        setIsLoader(false);
        return;
      }

      getuploadedAttachments(insp, 5, tableDataforFile);

      handleSnackOpen(response.responseMsg, "success");

      setFiles([]); // clear after success
      setIsLoader(false);
    })
    .catch((error) => {
      handleSnackOpen("Error : " + error, "error");
      setIsLoader(false);
    });
};

  const handleAcknowledge = () => {
    setIsLoader(true);

    const inspectionNumberId = data?.inspectionNumberId;
    const acknowledgeId = userDetails.userId;
    console.log("ins,ackid", inspectionNumberId, acknowledgeId);
    acknowledgeReport(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      inspectionNumberId,
      acknowledgeId
    )
      .then((response) => {
        if (response.response) {
          setIsLoader(false);
          handleSnackOpen(response.responseMsg, "success");

          if (userDetails.roleId === 12) {
            setTimeout(() => {
              navigate("/listInspection");
            }, 3000);
          }
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };
   



    const normalize = (str) => str?.trim().toLowerCase();

    const isValidStatus1 =
        (data?.statusId === 3 &&
            normalize(data?.statusName) ===
            "updated by supplier,pending at iqc engineer for approval") ||
        (data?.statusId === 6 &&
            normalize(data?.statusName) ===
            "acknowledged by iqc engineer") ||
        (data?.statusId === 4 &&
            normalize(data?.statusName) === "approved");
            //for approved and more 3 status validation this is added

    const handleGenerateSample = () => {
        if (data.lotNoBatchNoRouteSheet === formData.lotNoBatchNoRouteSheet) {
            alert("Please enter the different batch number, This is already exist");
           // handleSnackOpen("please enter the different batch number", "error");
            return;
        }
    const lotQuantity = formData.lotQuantity;
        const commodityId = formData.commodity;
        const inspectionNumber = data?.inspectionNumber ? data.inspectionNumber : inspData.inspectionNumber;

const batchNo = formData.lotNoBatchNoRouteSheet;
        console.log("inspectionNumber", inspectionNumber, "batchNo", batchNo);
    if (!commodityId) {
      handleSnackOpen("Please select commodity", "error");
      return;
    }
    if (
      !Number.isInteger(Number(lotQuantity)) ||
      Number(lotQuantity) < 2 ||
      Number(lotQuantity) > 3200
    ) {
      handleSnackOpen(
        "Lot Quantity must be a whole number between 2 and 3200",
        "error"
      );
      return;
    }

    if (!lotQuantity) {
      handleSnackOpen("Please enter Lot Quantity");
      return;
    }

    setIsLoader(true);

    fetch(
        
        `${baseApiURL}/PDIR/GetSampleSizes?lotQuantity=${lotQuantity}&commodityId=${commodityId}&inspectionNumber=${inspectionNumber}&batchNo=${batchNo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + siteToken.token,
          AzureToken: azureToken.token,
          userId: UID.id,
          UserEmail: userDetails.userEmail,
          RoleName: userDetails.role,
          Gid: userDetails.gid,
          Roleid: userDetails.roleId,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.result?.response) {
            const sample = data.result.objResult;
            console.log("sample", sample);
            console.log("inspectionnumberid1", data.result.objResult.inspectionNumberId);
            const newInspectionId = data?.result?.objResult.inspectionNumberId;
           setInspectionNumberId1(data.result.objResult.inspectionNumberId);
           setSampleSize(data.result.objResult.sampleSize);

           setFormData((prev) => ({
            ...prev,
            sampleCode: sample.code,
            sampleSize: sample.sampleSize,
            acceptPoint: sample.acceptPoint,
            rejectPoint: sample.rejectPoint,
           }));

            setDocuBtnList(prev => {
        console.log("Inside setDocuBtnList");

        const updated = prev.map(item => ({
            ...item,
            fileName: "",
            fileUrl: ""
        }));

        console.log("after clear", updated);

        return updated;
            });

          setSelectedRows([]);
          setData2([]);
          setTableDataforFile(prev =>
            prev.map(item => ({
              ...item,
              fileName: "",
              fileUrl: ""
            }))
          );

            setIsSampleGenerated(true);
            getInspectionLineItems(data?.result.objResult.inspectionNumberId);
            getUploadTableData(data?.result.objResult.inspectionNumberId);
            getObservations(data?.result.objResult.inspectionNumberId);
            getReviewersDDL(userDetails.supplierId, newInspectionId);
            handleSnackOpen(data?.result.responseMsg);

        } else {
          handleSnackOpen(
            data.result.responseMsg || "Failed to generate sample"
          );
        }
      })
      .catch((err) => {
        console.error(err);
        handleSnackOpen("Exception: " + err);
      })
      .finally(() => {
        setIsLoader(false);
      });
  };

  const handleDownloadSampleExcel = () => {
    const InspectionNoId = data?.inspectionNumberId
      ? data.inspectionNumberId
          : inspData.inspectionNoId;




    if (!sampleSize) {
      handleSnackOpen("Sample Size not available");
      return;
    }

    setIsLoader(true);

    fetch(
      `${baseApiURL}/PDIR/DownloadSampleExcel?sampleSize=${sampleSize}&InspectionNumberId=${InspectionNoId}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + siteToken.token,
          AzureToken: azureToken.token,
          userId: UID.id,
          UserEmail: userDetails.userEmail,
          RoleName: userDetails.role,
          Gid: userDetails.gid,
          Roleid: userDetails.roleId,
        },
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to download file");
        }
        return res.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Samples_${sampleSize}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error(err);
        handleSnackOpen("Excel download failed");
      })
      .finally(() => {
        setIsLoader(false);
      });
  };

  const handleUploadSample = async (file) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("UserId", userDetails.userId);
    formData.append("SampleSize", sampleSize);
    formData.append(
        "InspectionNumberId",
       
        (isValidStatus1 && inspectionNumberId1)
            ? inspectionNumberId1
            : data?.inspectionNumberId || inspData.inspectionNoId


      //data?.inspectionNumberId
      //      ? data.inspectionNumberId : data?.statusId == 4 && data?.statusName == "Approved" ? inspectionNumberId1
      //  : inspData.inspectionNoId
    );
    setIsLoader(true);
    try {
      const res = await fetch(`${baseApiURL}/PDIR/UploadSamples`, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + siteToken.token,
          AzureToken: azureToken.token,
          userId: UID.id,
          UserEmail: userDetails.userEmail,
          RoleName: userDetails.role,
          Gid: userDetails.gid,
          Roleid: userDetails.roleId,
        },
        body: formData,
      });

      const data1 = await res.json();

      if (data1.result && data1.result.response) {
        handleSnackOpen(
          data1.result.responseMsg || "Upload Successful",
          "success"
        );

        setTimeout(() => {
            getInspectionLineItems(

                (isValidStatus1 && inspectionNumberId1)
                    ? inspectionNumberId1
                    : data?.inspectionNumberId || inspData.inspectionNoId
            //data?.inspectionNumberId
            //  ? data.inspectionNumberId
            //  : inspData.inspectionNoId //earlier
            );


            //const cleanedRows = cleanSampleDataIfApproved(result || []);

            //setRows(cleanedRows);

        }, 1500);
      } else {
        handleSnackOpen(data1.result.responseMsg || "Upload Failed", "error");
      }
    } catch (err) {
      //setIsLoader(false);
      console.error(err);
      handleSnackOpen("Exception: " + err);
    } finally {
      setIsLoader(false);
    }
  };

  // handleDownloadLineItemSampleExcel
  const handleDownloadLineItemSampleExcel = async () => {
    //const InspectionNoId = data?.inspectionNumberId
    //    ? data.inspectionNumberId : (data?.statusId == 4 && data?.statusName == "Approved") ? inspectionNumberId1
    //          : inspData.inspectionNoId;


      const InspectionNoId =
          (isValidStatus1 && inspectionNumberId1)
              ? inspectionNumberId1
              : data?.inspectionNumberId || inspData.inspectionNoId;

    if (!InspectionNoId) {
      alert("InspectionNoId is not available");
      return;
    }
    setIsLoader(true);
    try {
      const res = await fetch(
        `${baseApiURL}/PDIR/DownloadUploadedSheet?InspectionNoId=${InspectionNoId}`,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            userId: UID.id,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
          },
        }
      );

      if (!res.ok) {
        throw new Error("Download failed");
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Samples_${sampleSize}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
      setTimeout(() => {
        setIsLoader(false);
      }, 100);
    } catch (err) {
      //setIsLoader(false);
      console.error(err);
      alert("Error downloading sample excel");
    }
  };
  const [reviwerApprove, setreviwerApprove] = useState(false);
  const handleReviewer = async () => {
    setIsLoader(true);
    try {
      const inspectionId = data?.inspectionNumberId;
      const reviewerId = userDetails.userId;

      const response = await fetch(
        `${baseApiURL}/PDIR/ReviewedReport?InspectionNumberId=${inspectionId}&ReviewerId=${reviewerId}`,
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            userId: UID.id,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
          },
        }
      );

      const result = await response.json();

      if (result?.result?.response) {
        handleSnackOpen(result.result.responseMsg);
        if (result.result.responseMsg) {
          console.log("approvebyreviwer", result.result.responseMsg);
          setreviwerApprove(true);
        }
        setTimeout(() => {
          if ([1, 2, 6, 3].includes(userDetails.roleId)) {
            navigate("/viewInspection");
          }
        }, 3000);
      } else {
        handleSnackOpen(result?.result?.responseMsg || "Review failed");
      }
    } catch (error) {
      console.error("Review API Error", error);
    } finally {
      setIsLoader(false);
    }
  };



   
  const handleSaveAsDraft = async () => {
    setIsLoader(true);
    const inspectionId = data?.inspectionNumberId;
      const inspectionNumberId = (isValidStatus1 && inspectionNumberId1)
          ? inspectionNumberId1 : data?.inspectionNumberId;
    const payload = {
      inspectionId: inspectionId || 0,
      inspectionNumberId: inspectionNumberId || null,

      supplierId: formData.supplierId,
      supplierCode: formData.supplierCode,
      supplierName: formData.supplierName,

      commodityId: formData.commodity,
      partId: formData.partId,
      ProductType: formData.productType,

      pono: formData.pono || null,
      workOrdeNo: formData.workOrdeNo,

      startDate: dateInputs.startDate || null,
      endDate: dateInputs.endDate || null,

      lotQuantity: formData.lotQuantity || null,
      sampleQuantity: formData.sampleQuantity || null,

      lotNoBatchNoRouteSheet: formData.lotNoBatchNoRouteSheet,
      observation: formData.obserVation,

      statusId: formData.statusId,
      statusName: formData.statusName,

      rejectedRemarks: formData.remark || "",

      inspectedBy: formData.inspectedById,
      inspectedByEmail: userDetails.userEmail,

      toBeCheckedBy: formData.toBeCheckedById || null,

      isActive: true,
      isApprovedOrRejected: null,

      userId: userDetails.userId,
    };

    console.log("Draft Inspection Payload", payload);

    try {
      const response = await axios.post(
        `${baseApiURL}/PDIR/DraftInspectionDetails`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            userId: UID.id,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
          },
        }
      );

      if (response?.data?.result) {
        handleSnackOpen(response.data.result.responseMsg, "success");
        setTimeout(() => {
          if ([1, 2, 6, 3].includes(userDetails.roleId)) {
            navigate("/viewInspection");
          }
        }, 3000);
      } else {
        handleSnackOpen(response?.data?.result?.responseMsg, "error");
      }
    } catch (error) {
      console.error("Draft save error", error);
      handleSnackOpen("Something went wrong while saving draft", "error");
    } finally {
      setIsLoader(false);
    }
  };

  //rejectreviwerreport
  const handleRejectReviwer = () => {
    if (!rejectRemarkBySupplier.trim()) {
      handleSnackOpen("Please enter remarks", "warning");
      setTimeout(() => {
        navigate("/viewInspection");
      }, 3000);
      return;
    }

    setIsLoader(true);

    const inspectionNumberId = data?.inspectionNumberId;
    const reviwerId = userDetails.userId;
    const reviewerRemark = rejectRemarkBySupplier;

    rejectReviewerReport(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      inspectionNumberId,
      reviwerId,
      reviewerRemark
    )
      .then((response) => {
        if (response?.response) {
          handleSnackOpen(response.responseMsg, "success");
          setOpenDialogReject(false);

          setTimeout(() => {
            if ([1, 2, 6, 3].includes(userDetails.roleId)) {
              navigate("/viewInspection");
            }
          }, 3000);
        } else {
          handleSnackOpen(response.responseMsg, "error");
        }
        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

    //const insNumberId = data?.inspectionNumberId || inspData?.inspectionNoId;earlier
    const insNumberId = (isValidStatus1 && inspectionNumberId1)
        ? inspectionNumberId1
        : data?.inspectionNumberId || inspData.inspectionNoId;


  const dynamicStyle = {
    marginTop: rows && rows.length > 0 ? "20px" : "0px",
    height: 500,
    padding: "2px",
  };



    useEffect(() => {
        if (insNumberId || inspectionNumberId1) {
            getObservations();
        }
    }, [insNumberId, inspectionNumberId1]);

    //observations

    const getObservations = async (inspectionId) => {
        try {
            const idToUse = inspectionId || inspectionNumberId1 || insNumberId;
            const response = await fetch(
                `${baseApiURL}/PDIR/GetObservations?inspectionId=${idToUse}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + siteToken.token,
                        AzureToken: azureToken.token,
                        userId: UID.id,
                        UserEmail: userDetails.userEmail,
                        RoleName: userDetails.role,
                        Gid: userDetails.gid,
                        Roleid: userDetails.roleId,
                    },
                }
            );

            const data = await response.json();

            if (data?.result?.response === true) {
                setObservationRow(data.result.objResult);
            } else {
                setObservationRow([]);
            }
        } catch (error) {
            console.error("Error fetching observations:", error);
        }
    };

  //const getObservations = async () => {
  //  try {
  //    const response = await fetch(
  //      `${baseApiURL}/PDIR/GetObservations?inspectionId=${insNumberId}`,
  //      {
  //        method: "GET",
  //        headers: {
  //          "Content-Type": "application/json",
  //          Authorization: "Bearer " + siteToken.token,
  //          AzureToken: azureToken.token,
  //          userId: UID.id,
  //          UserEmail: userDetails.userEmail,
  //          RoleName: userDetails.role,
  //          Gid: userDetails.gid,
  //          Roleid: userDetails.roleId,
  //        },
  //      }
  //    );

  //    const data = await response.json();

  //    if (data?.result?.response === true) {
  //      setObservationRow(data.result.objResult);
  //    } else {
  //      setObservationRow([]);
  //    }
  //  } catch (error) {
  //    console.error("Error fetching observations:", error);
  //  }
  //};

  //Add odservation

  const handleRowAddObservation = async (newData) => {
    try {
      setIsLoader(true);

      const payload = {
        ...newData,
        InspectionId: insNumberId,
        Observation: newData.fileName,
          CreatedBy: userDetails.userId || null,
       //   InspectionNumberId:
        //Response: newData.response,
      };

      const response = await fetch(
        `${baseApiURL}/PDIR/CreateOrUpdateObservation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            userId: UID.id,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result?.result?.response) {
        handleSnackOpen(result?.result?.responseMsg, "success");

        await getObservations(insNumberId);
      } else {
        handleSnackOpen(
          result.result.responseMsg || "Failed to add observation",
          "error"
        );
      }
    } catch (error) {
      console.error("Error adding observation:", error);
      handleSnackOpen("Exception occurred while adding observation");
    } finally {
      setIsLoader(false);
    }
  };

  const handleRowUpdateObservation = async (newData, oldData) => {
    try {
      setIsLoader(true);

      const payload = {
          InspectionId: (isValidStatus1 && inspectionNumberId1)? inspectionNumberId1 : insNumberId,
        CreatedBy: userDetails.userId || null,
        ObservationId: oldData.observationId,
        Response: newData.response || "",
        Observation: newData.observation || "",
      };

      const response = await fetch(
        `${baseApiURL}/PDIR/CreateOrUpdateObservation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            userId: UID.id,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result?.result?.response) {
        handleSnackOpen(result?.result?.responseMsg, "success");

        await getObservations(insNumberId);//neew to check
      } else {
        handleSnackOpen(
          result.result.responseMsg || "Failed to update observation"
        );
      }
    } catch (error) {
      console.error("Error updating observation:", error);

      handleSnackOpen("Exception occurred while updating observation");
    } finally {
      setIsLoader(false);
    }
  };

  const handleRowDeleteObservation = async (oldData, resolve, reject) => {
    setIsLoader(true);
    try {
      const observationId = oldData?.observationId;

      const response = await fetch(
        `${baseApiURL}/PDIR/DeleteObservation?observationId=${observationId}`,
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            userId: UID.id,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();

      if (result?.result?.response) {
        handleSnackOpen(result?.result?.responseMsg);
        await getObservations(insNumberId);
        resolve();
      } else {
        handleSnackOpen(result?.result?.responseMsg || "Delete failed");
        reject();
      }
    } catch (error) {
      console.error("Delete API Error", error);
      handleSnackOpen("Something went wrong while deleting");
    } finally {
      setIsLoader(false);
    }
    };


    //function onChangeSupplierName(event, value) {
    //    const partDesc = partNumber.find((x) => x.id === value.id)?.partDesc;
    //    if (
    //        props?.rowData?.status === "Draft" ||
    //        props?.rowData?.status === "Recall" ||
    //        props?.rowData?.status === "Sent back to Siemens"
    //    ) {
    //        props.setDraftInputs({
    //            ...props.draftInputs,
    //            partId: value.id,
    //            partNumber: value.partNumber,
    //            partDescription: partDesc,
    //        });
    //    } else {
    //        props.setCreateComplaintInputs({
    //            ...props.createComplaintInputs,
    //            partNumber: value.id,
    //            partDescription: partDesc,
    //        });
    //    }
    //}

  //disabled button logic

  const disabledEditDeleteObsercationButton = [
    "Pending by Supplier",
    "Drafted by Supplier",
    "Updated by Supplier, Pending for Review", 
    "Rejected by Reviewer, Sent back to Supplier",
    "Updated by Supplier,Pending at IQC Engineer for Approval",
    "Acknowledged by IQC Engineer",
    "Approved",
    "Rejected by IQC Engineer,Sent back to Supplier"
  ]

  const disabledEditDeleteObservationForSupplier = [
  "Updated by Supplier, Pending for Review",
  //"Updated by Supplier,Pending at IQC Engineer for Approval",//commented for enabling the 
  //"Acknowledged by IQC Engineer",
 // "Approved"
  ]

  

  const supplierDisabledStatuses = [
    "Updated by Supplier, Pending for Review",
    //"Updated by Supplier,Pending at IQC Engineer for Approval",
    //"Acknowledged by IQC Engineer",
    //"Approved",
  ];

  const creatorDisabledStatuses = [
    "Updated by Supplier, Pending for Review",
    "Updated by Supplier,Pending at IQC Engineer for Approval",
    "Acknowledged by IQC Engineer",
    "Approved",
    "Rejected by IQC Engineer,Sent back to Supplier",
  ];

  const isGenerateSampleDisabled =
    !formData.lotQuantity ||
    (userDetails.roleId === 3 &&
      supplierDisabledStatuses.includes(data?.statusName)) ||
    ([1, 2, 6].includes(userDetails.roleId) &&
      creatorDisabledStatuses.includes(data?.statusName)) ||
    userDetails.roleId === 12;

  const submitDisableMap = {
    3: [
     // "Approved",//later changes for adding new batch 
     // "Acknowledged by IQC Engineer",
     "Updated by Supplier, Pending for Review",
    //  "Updated by Supplier,Pending at IQC Engineer for Approval",
      //"Rejected,Sent back to Supplier",
    ],
    1: [
        "Drafted by Supplier",
        "Updated by Supplier, Pending for Review",
        "Rejected by Reviewer, Sent back to Supplier",
        "Updated by Supplier,Pending at IQC Engineer for Approval",
        "Acknowledged by IQC Engineer",
        "Approved", 
        "Rejected by IQC Engineer,Sent back to Supplier",
        "Pending by Supplier"
    ],
    2: [
      "Drafted by Supplier",
      "Updated by Supplier, Pending for Review",
      "Rejected by Reviewer, Sent back to Supplier",
      "Updated by Supplier,Pending at IQC Engineer for Approval",
      "Acknowledged by IQC Engineer",
      "Approved", 
      "Rejected by IQC Engineer,Sent back to Supplier",
      "Pending by Supplier"
    ],
    6: [
      "Drafted by Supplier",
      "Updated by Supplier, Pending for Review",
      "Rejected by Reviewer, Sent back to Supplier",
      "Updated by Supplier,Pending at IQC Engineer for Approval",
      "Acknowledged by IQC Engineer",
      "Approved", 
      "Rejected by IQC Engineer,Sent back to Supplier",
      "Pending by Supplier"
    ],
  };
  const isSubmitDisabled = submitDisableMap[userDetails?.roleId]?.includes(
    data?.statusName
  );

  const showRemark =
    userDetails.roleId === 3 &&
    (data?.statusName === "Rejected by IQC Engineer,Sent back to Supplier" ||
      data?.statusName === "Updated by Supplier, Pending for Review");

  const disabledAddStatusesForRoles126 = [
    "Drafted by Supplier",
    "Updated by Supplier, Pending for Review", 
    "Rejected by Reviewer, Sent back to Supplier",
    "Updated by Supplier,Pending at IQC Engineer for Approval",
    "Acknowledged by IQC Engineer",
    "Approved",
    "Rejected by IQC Engineer,Sent back to Supplier",
    "Pending by Supplier"
  ];

  const disabledAddButton =
    userDetails.roleId === 12 ||
    ([1, 2, 6]?.includes(userDetails.roleId) &&
    disabledAddStatusesForRoles126.includes(data?.statusName));

  //const disabledDraftStatusesForSupplier = [
  //  "Updated by Supplier, Pending for Review",
  //  "Updated by Supplier,Pending at IQC Engineer for Approval",
  //  "Acknowledged by IQC Engineer",
  //  "Approved",
  //  ];
  //nidhi's code for save as draft disabled earlier

  const disabledDraftStatusesForSupplier = [
    "Updated by Supplier, Pending for Review",
   // "Updated by Supplier,Pending at IQC Engineer for Approval",
    //"Acknowledged by IQC Engineer",//2-3 commented for later batch new creation changes
    //"Approved",--changes done by shivani when approved-->make save as draft enable
    //"Rejected by Reviewer, Sent back to Supplier",
  ];

  const disabledSaveButtonForSupplier = {
    1:[
    "Drafted by Supplier",
    "Updated by Supplier, Pending for Review",
    "Rejected by Reviewer, Sent back to Supplier",
    "Updated by Supplier,Pending at IQC Engineer for Approval",
    "Acknowledged by IQC Engineer",
    //"Approved", 
    "Rejected by IQC Engineer,Sent back to Supplier",
    "Pending by Supplier"
    ],
    2:[
      "Drafted by Supplier",
      "Updated by Supplier, Pending for Review",
      "Rejected by Reviewer, Sent back to Supplier",
      "Updated by Supplier,Pending at IQC Engineer for Approval",
      "Acknowledged by IQC Engineer",
      "Approved", 
      "Rejected by IQC Engineer,Sent back to Supplier",
      "Pending by Supplier"
      ],
    6:[
        "Drafted by Supplier",
        "Updated by Supplier, Pending for Review",
        "Rejected by Reviewer, Sent back to Supplier",
        "Updated by Supplier,Pending at IQC Engineer for Approval",
        "Acknowledged by IQC Engineer",
        "Approved", 
        "Rejected by IQC Engineer,Sent back to Supplier",
        "Pending by Supplier"
      ],
      3:[
    //"Updated by Supplier,Pending at IQC Engineer for Approval",
   // "Approved",--commented for new batch changes
    //"Acknowledged by IQC Engineer",
    "Updated by Supplier, Pending for Review"
      ]

  };

  const isSaveDisabled = disabledSaveButtonForSupplier[userDetails?.roleId]?.includes(
    data?.statusName
    );


    //const roleId = userDetails?.roleId;
    //const roleName = userDetails?.role;
    //const status = data?.statusName;

    //const isSupplier = roleName === "Supplier";


    //const isSaveDisabled1 =
    //    roleId === 3 && isSupplier
    //        ? (
    //            !isSampleGenerated ||   //  main condition
    //            disabledSaveButtonForSupplier[3]?.includes(status)
    //        )
    //        : disabledSaveButtonForSupplier[roleId]?.includes(status);//nwely added working code -->checking for alternavtive



  const diasbledUploadButtonForSupplier ={
  1: [
    "Drafted by Supplier",
    "Updated by Supplier, Pending for Review",
    "Rejected by Reviewer, Sent back to Supplier",
    "Updated by Supplier,Pending at IQC Engineer for Approval",
    "Acknowledged by IQC Engineer",
   // "Approved",
    "Rejected by IQC Engineer,Sent back to Supplier",
    "Pending by Supplier"
  ],
  2: [
    "Drafted by Supplier",
    "Updated by Supplier, Pending for Review",
    "Rejected by Reviewer, Sent back to Supplier",
    "Updated by Supplier,Pending at IQC Engineer for Approval",
    "Acknowledged by IQC Engineer",
   // "Approved",
    "Rejected by IQC Engineer,Sent back to Supplier",
    "Pending by Supplier"
  ],
  6: [
    "Drafted by Supplier",
    "Updated by Supplier, Pending for Review",
    "Rejected by Reviewer, Sent back to Supplier",
    "Updated by Supplier,Pending at IQC Engineer for Approval",
    "Acknowledged by IQC Engineer",
    //"Approved",
    "Rejected by IQC Engineer,Sent back to Supplier",
    "Pending by Supplier"
  ],
  3:[
    //"Updated by Supplier,Pending at IQC Engineer for Approval",
    //"Approved",
   // "Acknowledged by IQC Engineer",
    "Updated by Supplier, Pending for Review"
      ]
}

const isUploadDisabled = diasbledUploadButtonForSupplier[userDetails?.roleId]?.includes(
  data?.statusName
);

  const canEdit =
  (
    userDetails.roleId === 3 && 
    !disabledEditDeleteObservationForSupplier.includes(data?.statusName)
  ) ||
  (
    [1, 2, 6].includes(userDetails.roleId) &&
    !disabledEditDeleteObsercationButton.includes(data?.statusName)
  );

  const canDelete = 
  [1,2,6].includes(Number(userDetails.roleId)) &&
  !disabledEditDeleteObsercationButton.includes(data?.statusName);



//part Attchment add button
  const disabledStatusesForAdd = [
    "Drafted by Supplier",
    "Updated by Supplier, Pending for Review",
    "Rejected by Reviewer, Sent back to Supplier",
    "Updated by Supplier,Pending at IQC Engineer for Approval",
    "Acknowledged by IQC Engineer",
    "Approved",
    "Rejected by IQC Engineer,Sent back to Supplier",
    "Pending by Supplier"
  ];

 
  const isAddDisabled =
  [1,2,6].includes(userDetails?.roleId) &&
        disabledStatusesForAdd.includes(data?.statusName);//earlier


    //const isApproved =
    //    data?.statusId === 4 && data?.statusName == "Approved";

    //const isAddDisabled =
    //    (
    //        [1, 2, 6].includes(Number(userDetails?.roleId)) &&
    //        disabledStatusesForAdd.includes(data?.statusName)
    //    ) &&
    //    !(Number(userDetails?.roleId) === 3 && isApproved);//modified--shivani



  const disabledAddObservation = [
    "Drafted by Supplier",
    "Updated by Supplier, Pending for Review",
  //  "Rejected by Reviewer, Sent back to Supplier",
   // "Updated by Supplier,Pending at IQC Engineer for Approval",
   // "Acknowledged by IQC Engineer",
   // "Approved",
  //  "Rejected by IQC Engineer,Sent back to Supplier",
    "Pending by Supplier" 
    ]

      //((data?.statusId == 4 && data?.statusName !== "Approved") || (data?.statusId !== 3 && data?.statusName !== "Updated by Supplier,Pending at IQC Engineer for Approval") || (data?.statusId == 6 && data?.statusName === "Acknowledged by IQC Engineer")
       //   || (data?.statusId == 5 && data?.statusName === "Rejected by IQC Engineer,Sent back to Supplier") || (data?.statusId == 1 && data?.statusName === "Submitted By Siemens Engineer and Pending with Supplier"))
        //removed statusname for avoing statusname matches issue
  const isAddObservationDisabled =
  userDetails.roleId === 12 ||
      userDetails.roleId === 3  ||
  ((userDetails.roleId === 1 || userDetails.roleId === 2 || userDetails.roleId === 6) &&
            disabledAddObservation.includes(data?.statusName));
//kept as it is

    //const isApproved = data?.statusId == 4 && data?.statusName === "Approved";
    //const isRole3 = Number(userDetails?.roleId) === 32;

    //// Enable editing only when BOTH true
    //const canEditApproved = isRole3 && isApproved;


    const disabledEditLineItemButton = [
      "Updated by Supplier, Pending for Review",
     // "Updated by Supplier,Pending at IQC Engineer for Approval",
     // "Acknowledged by IQC Engineer",
      //"Approved"
     ]

    const disabledEditDeleteLineItem = [
      "Pending by Supplier",
      "Drafted by Supplier",
      "Updated by Supplier, Pending for Review", 
      "Rejected by Reviewer, Sent back to Supplier",
      "Updated by Supplier,Pending at IQC Engineer for Approval",
      "Acknowledged by IQC Engineer",
      //"Approved",
      "Rejected by IQC Engineer,Sent back to Supplier"
    ]

    // const isRestrictedRole = [1, 2, 6].includes(Number(userDetails?.roleId));
    // const isStatusMatched = disabledEditDeleteLineItem.includes(data?.statusName);
    //const shouldDisableActions = isRestrictedRole && isStatusMatched;
    const shouldDisableActions =
  (userDetails.roleId === 3 &&
    disabledEditLineItemButton.includes(data?.statusName)) ||
  ([1, 2, 6].includes(userDetails.roleId) &&
    disabledEditDeleteLineItem.includes(data?.statusName));

    //const userRole = userDetails.role
    //console.log("userRole", userRole);
    //const READ_ONLY_ROLES = ["Supplier", "Admin"];
    //console.log("READ_ONLY_ROLES", READ_ONLY_ROLES);
    //const isReadOnly = READ_ONLY_ROLES.includes(userRole);
    //console.log("isReadOnly", isReadOnly);
  return (
      <Box style={{ border: "1px solid grey", padding: "10px" }}>
          <div className="left-div">
              <h3 className="heading">Add Inspection Report</h3>
          </div>
     {/* <h3>Add Inspection Report</h3>*/}
      <p
        style={{
          textAlign: "right",
          marginRight: "60px",
          marginBottom: "30px",
        }}
      >
        <span style={{ backgroundColor: "#00FFB9", padding: "5px" }}>
          Inspection Number :{/* {inspData?.inspectionNumber} */}
          {data?.inspectionNumber
            ? data.inspectionNumber
            : inspData.inspectionNumber}
        </span>
      </p>
      <form>
              <Grid container spacing={2} >
                  {userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 6 ?
                   <Grid item xs={12} sm={6} md={4} >
                      <FormControl fullWidth variant = "standard">
                          {/*<InputLabel shrink  id="supplier-label" sx={{ opacity: 0, fontSize: '12px', color: '#6c757d', position: 'relative', top: '0px', left: '0px', transform: 'none', Bottom: '40px', padding: '23px !important', backgroundColor:'none' }}>*/}
                          {/*    Supplier name <span style={{ color: 'red' }}>*</span>*/}
                          {/*</InputLabel>original code*/} 

                          <InputLabel shrink id="supplier-label" sx={{ opacity: 0, fontSize: '12px', color: '#6c757d', position: 'relative', top: '0px', left: '0px', transform: 'none', Bottom: '40px', backgroundColor: 'none' }}>
                              Supplier name <span style={{ color: 'red' }}>*</span>
                          </InputLabel>
                                

                          <Autocomplete sx={{ mt: '10px' }}
                             style={{ marginTop: '20px' }}
                          freeSolo
                              options={supplierList}
                          
                          value={
                              supplierList.find(
                                  (s) => s.supplierId === formData.supplierId
                              ) || null
                          }
                             // disabled={!isDisabled } 
                          getOptionLabel={(option) => option?.supplierName || ""}
                          onInputChange={(event, value) => {
                              fetchSuppliers(value, (list) => {
                                  SetSupplierList(list);
                              });

                              setFormData({
                                  ...formData,
                                  supplierName: value,
                              });
                          }}
                          onChange={(e, value) => {
                              console.log("e", value);
                              setFormData({
                                  ...formData,
                                  supplierId: value?.supplierId || "",
                                  supplierName: value?.supplierName || "",
                                  supplierCode: value?.supplierCode || "",
                              });
                          }}
                    
                          renderInput={(params) => (
                              <TextField
                                          
                                  {...params}
                                  label={null}
                                  variant="standard"
                                  InputProps={{
                                      ...params.InputProps,
                                      inputComponent: BootstrapInput,
                                      disableUnderline: true,
                                     /* readOnly: isReadOnly,*/
                                  }}
                                  style={{
                                      width: '100%', padding: '0px', 
                                  }}
                                  //renderInput={(params) => (
                                  //    <TextField
                                  //    {...params}
                                  //        label={
                                  //            <>
                                  //                Supplier Name <span style={{color: "red"} }>*</span>
                                  //            </>}
                                  //        variant="standard"
                                  //        InputProps={{
                                  //            ...params.InputProps,
                                  //            inputComponent: BootstrapInput,
                                  //            disableUnderline: true,
                                  //        }}
                               
                              />

                          )}
                      />
                      </FormControl>
                  </Grid>: ""}
                


             {/* ///updated coode*/}

              {/*    <Grid item xs={12} sm={6} md={4} >*/}
                     

              {/*        <Autocomplete*/}
              {/*            // className="autodropdown"*/}
              {/*           // style={{ marginTop: '10px', height: '10px' }}*/}
              {/*freeSolo*/}
              {/*options={supplierList}*/}
              {/*value={*/}
              {/*  supplierList.find(*/}
              {/*    (s) => s.supplierId === formData.supplierId*/}
              {/*  ) || null*/}
              {/*}*/}
              {/*getOptionLabel={(option) => option?.supplierName || ""}*/}
              {/*onInputChange={(event, value) => {*/}
              {/*  fetchSuppliers(value, (list) => {*/}
              {/*    SetSupplierList(list);*/}
              {/*  });*/}

              {/*  setFormData({*/}
              {/*    ...formData,*/}
              {/*    supplierName: value,*/}
              {/*  });*/}
              {/*}}*/}
              {/*                    onChange={(e, value) => {*/}
              {/*                        console.log("e", value);*/}
              {/*  setFormData({*/}
              {/*    ...formData,*/}
              {/*    supplierId: value?.supplierId || "",*/}
              {/*    supplierName: value?.supplierName || "",*/}
              {/*    supplierCode: value?.supplierCode || "",*/}
              {/*  });*/}
              {/*            }}*/}
              {/*           // input={<BootstrapInput />}*/}
              {/*renderInput={(params) => (*/}
              {/*    <TextField*/}
              {/*        // className="autodropdown"*/}
              {/*        //style={{*/}
              {/*        //    height: '50px', border:'1px solid black',borderRadius:'20px'*/}
              {/*        //}}*/}
              {/*        sx={{*/}
              {/*            width: '100%',*/}
              {/*            //height:'50px',*/}
              {/*            // Target the root of the outlined input*/}
              {/*            '& .MuiOutlinedInput-root': {*/}
              {/*                height: '8px',*/}
              {/*                borderRadius: '20px',*/}
              {/*                '& fieldset': {*/}
              {/*                    borderColor: 'black', // The actual border*/}
              {/*                },*/}
              {/*                '&:hover fieldset': {*/}
              {/*                    borderColor: 'blue', // Border color on hover*/}
              {/*                },*/}
              {/*                '&.Mui-focused fieldset': {*/}
              {/*                    borderColor: 'green', // Border color when active*/}
              {/*                },*/}
              {/*            },*/}
              {/*            // Target the label*/}
              {/*            '& .MuiInputLabel-root': {*/}
              {/*                color: 'gray',*/}
              {/*                '&.Mui-focused': {*/}
              {/*                    color: 'green',*/}
              {/*                },*/}
              {/*            },*/}
              {/*        }}*/}
              {/*    {...params}*/}
              {/*    value={formData.supplierId}*/}
              {/*    disabled={*/}
              {/*      userDetails.roleId === 12 || userDetails.roleId === 3*/}
              {/*    }*/}
              {/*    label={*/}
              {/*      <>*/}
              {/*        Supplier Name <span style={{ color: "red" }}>*</span>*/}
              {/*      </>*/}
              {/*    }*/}
              {/*    variant="outlined"*/}
              {/*    fullWidth*/}
              {/*    InputLabelProps={{ shrink: true }}*/}
              {/*    />*/}
               
              {/*)}*/}
              {/*                />*/}
              {/*        */}{/*    </BootstrapInput>*/}
              {/*        */}{/*</FormControl>*/}
              {/*    </Grid>*/}


                  {/*<Grid item xs={12} sm={6} md={3}>*/}
                  {/*    <UseAutocomplete*/}
                  {/*        title="Supplier Name **"*/}
                  {/*        onChange={onChangeSupplierName}*/}
                  {/*        defaultValue={*/}
                  {/*            props.rowData*/}
                  {/*                ? props.rowData.status === "Draft" ||*/}
                  {/*                    props.rowData.status === "Recall" ||*/}
                  {/*                    (props?.rowData?.status === "Sent back to Siemens" &&*/}
                  {/*                        userDetails.roledId !== 3)*/}
                  {/*                    ? props.draftInputs.partNo*/}
                  {/*                    : {*/}
                  {/*                        partId: props.rowData.partId,*/}
                  {/*                        partNumber: props.rowData.partNumber,*/}
                  {/*                    }*/}
                  {/*                : props.createComplaintInputs.partId*/}
                  {/*        }*/}
                  {/*        disable={disable}*/}
                  {/*    />*/}
                  {/*</Grid>*/}

                  {/*<Grid item xs={12} sm={6} md={4}>*/}
                  {/*    <FormControl fullWidth>*/}
                  {/*        <InputLabel shrink htmlFor="bootstrap-input">*/}
                  {/*            Supplier name*/}
                  {/*        </InputLabel>*/}
                  {/*        <BootstrapInput>*/}
                  {/*    <Autocomplete*/}
                  {/*        freeSolo*/}
                  {/*        options={supplierList}*/}
                  {/*        value={*/}
                  {/*            supplierList.find(*/}
                  {/*                (s) => s.supplierId === formData.supplierId*/}
                  {/*            ) || null*/}
                  {/*        }*/}
                  {/*        getOptionLabel={(option) => option?.supplierName || ""}*/}
                  {/*        onInputChange={(event, value) => {*/}
                  {/*            fetchSuppliers(value, (list) => {*/}
                  {/*                SetSupplierList(list);*/}
                  {/*            });*/}

                  {/*            setFormData({*/}
                  {/*                ...formData,*/}
                  {/*                supplierName: value,*/}
                  {/*            });*/}
                  {/*        }}*/}
                  {/*        onChange={(e, value) => {*/}
                  {/*            setFormData({*/}
                  {/*                ...formData,*/}
                  {/*                supplierId: value?.supplierId || "",*/}
                  {/*                supplierName: value?.supplierName || "",*/}
                  {/*                supplierCode: value?.supplierCode || "",*/}
                  {/*            });*/}
                  {/*        }}*/}
                  {/*        input={<BootstrapInput />}*/}
                  {/*                renderInput={(params) => (*/}
                  {/*                    <Select*/}
                  {/*               // className="make"*/}
                  {/*                {...params}*/}
                  {/*                value={formData.supplierId}*/}
                  {/*                disabled={*/}
                  {/*                    userDetails.roleId === 12 || userDetails.roleId === 3*/}
                  {/*                }*/}
                  {/*                label={*/}
                  {/*                    <>*/}
                  {/*                        Supplier Name <span style={{ color: "red" }}>*</span>*/}
                  {/*                    </>*/}
                  {/*                }*/}
                  {/*               // variant="outlined"*/}
                  {/*                fullWidth*/}
                  {/*                InputLabelProps={{ shrink: true }}*/}
                  {/*            />*/}
                  {/*        )}*/}
                  {/*            />*/}
                  {/*        </BootstrapInput>*/}
                  {/*    </FormControl>*/}
                  {/*</Grid>  */}

                  {userDetails.roleId == 3 || userDetails.roleId == 12 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10 ? <Grid item xs={12} sm={6} md={4}>

                      <FormControl fullWidth>
                          <InputLabel shrink htmlFor="bootstrap-input">
                              Supplier Name<span style={{ color: 'red' }}>*</span>
                          </InputLabel>
                          <BootstrapInput
                              label="Supplier Name"
                              value={formData.supplierName}
                              onChange={handleChange}
                              disabled={userDetails.roleId === 12 || userDetails.roleId === 3}
                              name="Supplier name"
                              fullWidth
                              variant="outlined"
                              placeholder="Supplier Name"
                              InputLabelProps={{
                                  shrink: true,
                              }}
                          />
                      </FormControl>
                  </Grid> : ""}

          <Grid item xs={12} sm={6} md={4}>
                      
                          <FormControl fullWidth>
                              <InputLabel shrink htmlFor="bootstrap-input">
                                  Supplier Code
                              </InputLabel>
                          <BootstrapInput
                label="Supplier Code"
                value={formData.supplierCode}
                onChange={handleChange}
                disabled={userDetails.roleId === 12 || userDetails.roleId === 3}
                name="Supplier code"
                fullWidth
               variant="outlined"
                placeholder="Supplier Code"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Grid>

          {!(userDetails.roleId === 3 || showFields) && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth >
                <InputLabel
                  shrink
                  id="commodity-label"
                  sx={{
                    fontSize: "12px",
                    color: "#6c757d",
                    ml: "4px",
                  }}
                >
                  Commodity <span style={{ color: "red" }}>*</span>
                </InputLabel>

                <Select
                  labelId="commodity-label"
                  id="commodity"
                  name="commodity"
                  onChange={handleSelectChange}
                  value={formData.commodity}
                  label="Commodity *"
                                  disabled={userDetails.roleId === 12}
                                  input={<BootstrapInput />}
                >
                  {commodityList?.map((item) => (
                    <MenuItem key={item.commodityId} value={item.commodityId}>
                      {item.commodity}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
                  )}

                 

                  <Grid item xs={12} sm={6} md={4}>

                      <FormControl fullWidth variant="standard">
                        

                          <InputLabel shrink id="supplier-label" sx={{ opacity: 0, fontSize: '12px', color: '#6c757d', position: 'relative', top: '0px', left: '0px', transform: 'none', Bottom: '40px', padding: '23px !important', backgroundColor: 'none' }}>
                              Part No<span style={{ color: 'red' }}>*</span>
                          </InputLabel>
                          <Autocomplete sx={{ mt: '10px' }}
                              style={{ marginTop: '20px' }}
              freeSolo
              options={spirdonList}
              value={
                spirdonList.find((s) => s.partNumber === formData.partNumber) ||
                null
              }
              getOptionLabel={(option) => option?.partNumber || ""}
              onInputChange={(event, value) => {
                fetchSpiridon(value, (list) => {
                  SetSpirdonList(list);
                });

                setFormData({
                  ...formData,
                  partNumber: value,
                });
              }}
              onChange={(e, value) => {
                setFormData({
                  ...formData,
                  partId: value?.partId || "",
                  partNumber: value?.partNumber || "",
                  partDescription: value?.partDescription || "",
                });
              }}
              renderInput={(params) => (
                <TextField
                 /* {...params}*/
                  disabled={
                    userDetails.roleId === 12 || userDetails.roleId === 3
                  }
                  //label={
                  //  <>
                  //    Part No <span style={{ color: "red" }}>*</span>
                  //  </>
                  //}
                  //variant="outlined"
                  //fullWidth
                  //    InputLabelProps={{ shrink: true }}



                      ////
                      {...params}
                      label={null}
                      variant="standard"
                      InputProps={{
                          ...params.InputProps,
                          inputComponent: BootstrapInput,
                          disableUnderline: true,
                      }}
                      style={{
                          width: '100%', padding: '0px',
                      }}
                />
              )}
                          />
                      </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
           
                <FormControl fullWidth>
                              <InputLabel shrink htmlFor="bootstrap-input">
                                  Description
                              </InputLabel>
                              <BootstrapInput
                label="Description"
                disabled={userDetails.roleId === 12 || userDetails.roleId === 3}
                value={formData.partDescription}
                onChange={handleChange}
                name="description"
                fullWidth
                variant="outlined"
                placeholder="Description"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
          
                <FormControl fullWidth>
                              <InputLabel shrink htmlFor="bootstrap-input">
                              Product
                              </InputLabel>
                              <BootstrapInput
                label="Product"
                disabled={userDetails.roleId === 12 || userDetails.roleId === 3}
                value={formData.productType}
                onChange={handleChange}
                name="productType"
                fullWidth
                variant="outlined"
                placeholder="Product"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Grid>

          {(userDetails.roleId === 3 ||
            userDetails.roleId === 12 ||
            showFields) && (
            <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth>
                              <InputLabel shrink htmlFor="bootstrap-input">
                                  Po No
                              </InputLabel>
                              <BootstrapInput
                  label="Po No"
                  value={formData.pono}
                  disabled={userDetails.roleId === 12}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9]/g, "");
                    if (value.length > 10) return;

                    setFormData({
                      ...formData,
                      pono: value,
                    });
                  }}
                  name="pono"
                  fullWidth
                  variant="outlined"
                  placeholder="PO No"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Grid>
          )}

          {(userDetails.roleId === 3 ||
            userDetails.roleId === 12 ||
            showFields) && (
            <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth>
                              <InputLabel shrink htmlFor="bootstrap-input">
                                  Work Order No.
                              </InputLabel>
                              <BootstrapInput
                  label="Work Order No."
                  className="mt-1"
                  disabled={userDetails.roleId === 12}
                  value={formData.workOrdeNo}
                  onChange={handleChange}
                  name="workOrdeNo"
                  fullWidth
                  variant="outlined"
                  placeholder="Work Order No."
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Grid>
          )}

          {(userDetails.roleId === 3 ||
            userDetails.roleId === 12 ||
            showFields) && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Start Date
                              </InputLabel>


                <BootstrapInput
                  disabled={userDetails.roleId === 12}
                  label="start Date."
                  type="date"
                  id="bootstrap-input"
                  name="startDate"
                  onChange={handleDateChange}
                  value={dateInputs.startDate}
                />
              </FormControl>
            </Grid>
          )}

          {(userDetails.roleId === 3 ||
            userDetails.roleId === 12 ||
            showFields) && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  End Date
                </InputLabel>

                <BootstrapInput
                  type="date"
                  id="bootstrap-input"
                  name="endDate"
                  onChange={handleDateChange}
                  value={dateInputs.endDate}
                  disabled={userDetails.roleId === 12}
                  inputProps={{ min: dateInputs.startDate }}
                  //min={dateInputs.startDate}
                />
              </FormControl>
            </Grid>
          )}

          {(userDetails.roleId === 3 ||
            userDetails.roleId === 12 ||
            showFields) && (
            <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth>
                              <InputLabel shrink htmlFor="bootstrap-input">
                                  Batch No.
                              </InputLabel>
                              <BootstrapInput
                                 
                  label="Batch No."
                  disabled={userDetails.roleId === 12}
                  value={formData.lotNoBatchNoRouteSheet}
                  onChange={handleChange}
                  name="lotNoBatchNoRouteSheet"
                  fullWidth
                  variant="outlined"
                  placeholder="Batch No"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Grid>
          )}

          {(userDetails.roleId === 3 ||
            userDetails.roleId === 12 ||
            showFields) && (
            <>
              {/* ROW 2 */}
              {/* <Grid container spacing={3} alignItems="center" style={{marginTop:"10px" }}> */}
              <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth>
                                  <InputLabel shrink htmlFor="bootstrap-input">
                                      Lot Quantity
                                  </InputLabel>
                                  <BootstrapInput
                    label="Lot Quantity"
                    value={formData.lotQuantity}
                    onChange={handleChange}
                    name="lotQuantity"
                    disabled={userDetails.roleId === 12}
                    fullWidth
                    variant="outlined"
                    placeholder="Lot Quantity"
                    InputLabelProps={{ shrink: true }}
                  />
                </FormControl>
              </Grid>

                          <Grid item xs={12} sm={6} md={2} style={{ marginTop:"20px" }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={isGenerateSampleDisabled}
                  onClick={handleGenerateSample}
                  style={{
                    height: "50px",
                    minHeight: "50px",
                    lineHeight: "normal",
                  }}
                >
                  Generate Sample
                </Button>
              </Grid>
              {/* </Grid> */}
              {formData.sampleSize && (
                <Grid container spacing={3} alignItems="center" sx={{ mt: 1 }}>
                  <Grid item xs={12} sm={6} md={2} sx={{ pl: 4 }}>
                    <TextField
                      label="Sample Size"
                      value={formData.sampleSize || ""}
                      fullWidth
                      disabled
                      InputLabelProps={{ shrink: true }}
                      sx={{ mt: 2 }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      label="Sample Code"
                      value={formData.sampleCode || ""}
                      fullWidth
                      disabled
                      InputLabelProps={{ shrink: true }}
                      sx={{ mt: 2 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      label="Accept Point"
                      value={formData.acceptPoint || ""}
                      fullWidth
                      disabled
                      InputLabelProps={{ shrink: true }}
                      sx={{ mt: 2 }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      label="Reject Point"
                      value={formData.rejectPoint || ""}
                      fullWidth
                      disabled
                      InputLabelProps={{ shrink: true }}
                      sx={{ mt: 2 }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Button
                      variant="outlined"
                      color="success"
                      fullWidth
                      disabled={
                        !formData.sampleSize || userDetails.roleId === 12
                      }
                      onClick={handleDownloadSampleExcel}
                      sx={{ mt: 2 }}
                    >
                      Download Sample Excel
                    </Button>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Grid>
           {/*   && (inspectionNumberId1 == null || inspectionNumberId1 == undefined)*/}
        <Grid item xs={12}>
          <h3 className="title-heading">Part Attachment </h3>
          <p style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>
            <strong>Note:</strong> Maximum of 8 files allowed. Accepted file
            format <strong>.pdf only</strong>.
          </p>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} className="fileMatTable">
            <MaterialTable
              columns={columns1}
              data={uploadTableData}
              icons={tableIcons}
              isLoading={isLoader}
              options={tableOptionsAttachment}
                          editable={{
                              onRowAdd: !isAddDisabled 
                ? (newFormData) =>
                    new Promise((resolve, reject) => {
                      handleRowAdd(newFormData, resolve, reject);
                    })
                : undefined,
                onRowAddCancelled: () => {
                  setUploadedFileName("");
                  setSelectedFile(null);
                },
                onRowDelete: !isAddDisabled
                ?(oldFormData) =>
                  new Promise((resolve, reject) => {
                    const roleId = Number(userDetails?.roleId);

                    handleRowDelete(oldFormData, resolve, reject);
                  }):undefined,
                isDeletable: (rowData) =>
                  [1, 2, 6].includes(Number(userDetails?.roleId)), //  only 1,2,6 can see/delete
              }}
            />

            <>
              <SnackbarCustom
                open={open}
                message={snackMessage}
                alertType={alertType}
                handleClose={handleClose}
              />
            </>
          </Grid>
        </Grid>

        <div style={{ marginTop: "30px" }}>
          {userDetails.roleId !== 3 && (
            <h3 style={{ fontWeight: "600" }}>
              Add Line Items
              <Button
                disabled={disabledAddButton}
                style={{ padding: "5px", marginLeft: "20px" }}
                variant="contained"
                className="pt-button--primary"
                onClick={handleAdd}
              >
                Add
              </Button>
            </h3>
          )}

          <Box style={{ dynamicStyle }}>
            <Grid item xs={12}>
              <MaterialTable
                title="Dimensions"
                columns={columns}
                data={rows}
                icons={tableIconsInputScreen}
                isLoading={isLoader}
                options={{
                  // ...tableOptionsUser,
                  paging: false,
                  //pageSize: 5,
                  //pageSizeOptions: [5, 10, 20],
                  maxBodyHeight: 470,
                  minBodyHeight: 350,
                }}
                actions={[
                  ...(userDetails?.roleId === 3 ||
                  userDetails?.roleId === 12 ||
                  showFields
                    ? [
                        {
                          icon: () => (
                            <UploadAction onFileSelect={handleUploadSample} />
                          ),
                          tooltip: "Upload",
                          isFreeAction: true,
                          disabled: !isSampleGenerated,
                        },
                        {
                          icon: GetDownLoadButton,
                          tooltip: "Download",
                            isFreeAction: true,
                            //disabled: !isSampleGenerated,
                          onClick: () => handleDownloadLineItemSampleExcel(),
                        },
                      ]
                    : []),
                  ...(![3, 12].includes(userDetails?.roleId) && !shouldDisableActions
                    ? [
                        {
                          icon: GetEditButton,
                          isFreeAction: false,
                            //Hidden: shouldDisableActions,
                          //  disabled: !isSampleGenerated,
                          onClick: (e, rowData) => {
                          //if (shouldDisableActions) return;
                          handleEditaddLineItem(rowData);
                          },
                        },
                        {
                          icon: GetDeleteButton,
                          tisFreeAction: true,
                         // disabled: shouldDisableActions,
                          onClick: (e, rowData) => {
                            //if (shouldDisableActions) return;
                            handleDeleteIconClick(rowData);
                          },
                        },
                      ]
                    : []),
                ]}
                editable={
                                  userDetails?.roleId === 3 && isSampleGenerated
                    ? {
                        onRowUpdate: (newData, oldData) =>
                          new Promise((resolve, reject) => {
                            if (shouldDisableActions) {
                              resolve(); // block edit
                              return;
                            }
                            const payloadUpdate = {
                              LineItemId: oldData.lineItemId,
                              InspectionNumberId: oldData.inspectionNumberId,
                              BnNo: oldData.bnNo,
                              Specification: oldData.specification,
                              MinValue: oldData.minValue,
                              MaxValue: oldData.maxValue,
                              Sample1: oldData.sample1,
                              Sample2: oldData.sample2,
                              Sample3: oldData.sample3,
                              Sample4: oldData.sample4,
                              Sample5: oldData.sample5,
                              Sample6: oldData.sample6,
                              Sample7: oldData.sample7,
                              Sample8: oldData.sample8,
                              Sample9: oldData.sample9,
                              Sample10: oldData.sample10,
                              Result: oldData.result,
                              LowDimension: oldData.lowDimension,
                              HighDimension: oldData.highDimension,
                              PositiveTole: oldData.positiveTole,
                              NegativeTole: oldData.negativeTole,
                              Remarks: newData.remarks,
                              MeasuringInstrument: newData.measuringInstrument,
                              MeasurementID:
                                newData.measurementID || oldData.measurementID,
                              //MeasuringUnit:
                              //  newData.measurementUnit ||
                                //  oldData.measuringUnit,

                                MeasuringUnit:
                                    newData.measurementUnit ??
                                    oldData.measurementUnit ??
                                    oldData.measuringUnit,

                              ModifiedBy: userDetails.userId,
                            };

                            AddLineItemDetails(
                              siteToken.token,
                              azureToken.token,
                              UID.id,
                              userDetails.userEmail,
                              userDetails.gid,
                              userDetails.role,
                              userDetails.roleId,
                              payloadUpdate
                            )
                              .then((response) => {
                                if (response?.response === true) {
                                  const updatedRows = [...rows];
                                    const index = oldData.tableData.id;


                                    updatedRows[index] = {
                                        ...oldData,
                                        ...newData,

                                        remarks: newData.remarks ?? oldData.remarks,

                                        measuringInstrument:
                                            newData.measuringInstrument ?? oldData.measuringInstrument,

                                        measurementID:
                                            newData.measurementID ?? oldData.measurementID,


                                        measurementUnit:
                                            newData.measurementUnit ??
                                            oldData.measurementUnit ??
                                            oldData.measuringUnit,

                                    };

                                  //updatedRows[index] = {
                                  //  ...oldData,
                                  //    ...newData,

                                  //    measurementUnit:
                                  //        newData.measurementUnit ??
                                  //        oldData.measurementUnit ??
                                  //        oldData.measuringUnit,//added newly for checking measuring unit issue//earlier by me

                                  //};
                                  setRows(updatedRows);
                                  resolve();
                                } else {
                                  reject();
                                }
                              })
                              .catch((error) => {
                                reject();
                              });
                          }),
                      }
                    : {}
                }
              />
            </Grid>
          </Box>

          <Grid item xs={12} style={{ margin: "auto 0px 0px 0px" }}>
            <h3 className="title-heading">Observations..!!! </h3>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12} className="fileMatTable">
              <MaterialTable
                columns={columns2}
                data={observationRow}
                icons={tableIcons}
                isLoading={isLoader}
                options={tableOptionsAttachment}
                editable={{
                 onRowAdd:
                  isAddObservationDisabled
                    ? undefined
                    : (newData) =>
                        new Promise((resolve, reject) => {
                          if (observationRow.length >= 8) {
                            setSnackMessage("You can only add maximum 8 observations");
                            setAlertType("warning");
                            setOpen(true);
                            reject();
                            return;
                          }
              
                          handleRowAddObservation(newData);
                          resolve();
                        }),
                    onRowUpdate: (userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 6) ? canEdit : (isValidStatus2 && isSampleGenerated)
                  
                    ? (newData, oldData) =>
                          new Promise((resolve) => {
                          handleRowUpdateObservation(newData, oldData);
                          resolve();
                        })
                    : undefined,
                    onRowDelete: (userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 6) ? canDelete : (isValidStatus2 && isSampleGenerated)
                    ? (oldFormData) =>
                        new Promise((resolve, reject) => {
                          const roleId = Number(userDetails?.roleId);
                          handleRowDeleteObservation(
                            oldFormData,
                            resolve,
                            reject
                          );
                        })
                    : undefined,
                }}
              />

              <>
                <SnackbarCustom
                  open={open}
                  message={snackMessage}
                  alertType={alertType}
                  handleClose={handleClose}
                />
              </>
            </Grid>
          </Grid>
        </div>
        <div style={{ marginTop: "150px" }}>
          <Grid container spacing={1}>
            <Grid container spacing={3} style={{ marginTop: "20px" }}>
              {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink>Commodity</InputLabel>
                    <Select
                      name="commodity"
                      onChange={handleChange}
                      value={formData.commodity}
                      input={<BootstrapInput />}
                      disabled={
                        userDetails.roleId == 12 || userDetails.roleId == 3
                      }
                    >
                      {commodityList?.map((item) => (
                        <MenuItem
                          key={item.commodityId}
                          value={item.commodityId}
                        >
                          {item.commodity}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {(userDetails.roleId === 3 || showFields) && (
                <Grid
                  style={{ margin: "20px 0 0 0" }}
                  item
                  xs={12}
                  sm={6}
                  md={userDetails.roleId == 3 || showFields ? 9 : 12}
                >
                  <FormControl fullWidth>
                    <label>Observations</label>
                    <textarea
                      name="obserVation"
                      value={formData.obserVation}
                      disabled={userDetails.roleId == 12}
                      onChange={(e) => {
                        setIsObservationEdited(true); // user edited
                        setFormData((prev) => ({
                          ...prev,
                          obserVation: e.target.value, //  direct update
                        }));
                      }}
                      style={{ height: "90px", width: "600px" }}
                    />
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* commodity file upload */}
          {/* {isEditMode && ( */}
            <div style={{}}>
              <h3 style={{ marginLeft: "5px" }}>Commodity File List</h3>
              <MaterialTable
                title={"File Upload Table"}
                columns={columnsUploadData}
                data={tableDataforFile}
                //icons={tableIcons}
                //isLoading={isLoader}
                options={{
                  selection: true,
                  search: false,

                  rowStyle: (rowData) => ({
                    pointerEvents:
                      (userDetails.role === "Supplier"|| userDetails.role ==="IQC Engineer")&&
                        mandatoryDocs.includes(Number(rowData.docId))
                        ? "none"
                        : "auto",

                    opacity:
                      (userDetails.role === "Supplier"|| userDetails.role ==="IQC Engineer") &&
                        mandatoryDocs.includes(Number(rowData.docId))
                        ? 0.5
                        : 1,
                  }),
                }}
                onSelectionChange={(rows) => {
                  console.log("selected rows:", rows);

                  setSelectedRows(rows);
                }}
                selectedRows={selectedRows}
              />
              <Grid
                item
                xs={12}
                md={8}
                style={{
                  marginTop: "20px",
                  marginBottom: "40px",
                }}
              >
                <Button
                  className="pr-button--secondary bulk-upload-submit-btn submit"
                  onClick={handleFileUploadList}
                  // disabled={
                  //   selectedRows?.length === 0 ||
                  //   userDetails.roleId == 12 ||
                  //   userDetails.roleId == 1 ||
                  //   (userDetails.roleId == 3 &&
                  //     disabledSaveButtonForSupplier.includes(data?.statusName))
                  // }
                              disabled={
                                  (selectedRows?.length === 0 & (userDetails.roleId==1 || userDetails.roleId==2  || userDetails.roleId==6)) ||
                    userDetails.roleId === 12 ||
                      (isValidStatus2 && !isSampleGenerated)
                   
                  }
                >
                  Save
                </Button>
              </Grid>
              <Box>
                <Grid container spacing={2}>
                  {docuBtnList.length >= 1 && (
                    <Grid item xs={12}>
                      <p
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginTop: "4px",
                        }}
                      >
                        <strong>Note:</strong> Accepted file format{" "}
                        <strong>.pdf only</strong>.
                      </p>
                    </Grid>
                  )}
                  {docuBtnList?.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <TextField
                        label={
                          <>
                            {item.documentName}
                          {userDetails.roleId == 3 && (
                            <span style={{ color: "red" }}>*</span>
                          )}
                          </>
                        }
                        type="file"
                        id="drawingFile"
                        name={item.documentName}
                        className="label-font"
                        fullWidth
                        onChange={(e) =>
                          handleCommodityfileUpload(e, item.documentNameApi)
                        }
                        variant="filled"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          accept: "application/pdf/*",
                          multiple: false,
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                className="p-0"
                                target="_blank"
                              >
                                <CloudDownloadIcon
                                  onClick={() => downloadFileAttachment(item)}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      ></TextField>
                      <span>{item.fileName}</span>
                    </Grid>
                  ))}
                  {docuBtnList.length > 0 && (
                    <Grid item xs={12} sm={6} md={4}>
                      <Button
                        className="pt-button--hero myid-login-btn-block"
                        onClick={handleUploadFileData}
                        disabled={
                          userDetails.roleId == 12 ||
                            isUploadDisabled || (isValidStatus2 && !isSampleGenerated)
                        }
                      >
                        Upload
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </div>
          {/* )} */}

          {userDetails.roleId == 3 && (
            <Grid container spacing={3} style={{ marginTop: "20px" }}>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="Inspected By"
                  disabled
                  value= {formData.inspectedBy}
                 
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  select
                  fullWidth
                  // disabled={userDetails.roleId==12}
                  label={
                    <span>
                      To Be Checked By <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  value={formData.toBeCheckedById || ""}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      toBeCheckedById: Number(e.target.value),
                    }));
                  }}
                >
                  {reviewers.map((item) => (
                    <MenuItem key={item.userId} value={item.userId}>
                      {item.userEmail}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          )}

          {/*{showRemark && (*/}
          {/*  <Grid container spacing={3} style={{ marginTop: "20px" }}>*/}
          {/*    <Grid item xs={3}>*/}
          {/*      <TextField*/}
          {/*        fullWidth*/}
          {/*        multiline*/}
          {/*        rows={4}*/}
          {/*        disabled*/}
          {/*        label={<span>Remark</span>}*/}
          {/*        value={data?.rejectedRemarks || ""}*/}
          {/*      />*/}
          {/*    </Grid>*/}
          {/*  </Grid>*/}
          {/*)}*/}

          {/*&& data.statusName =="Updated by Supplier, Pending for Review"*/}
          {/*data.statusName =="Rejected by IQC Engineer,Sent back to Supplier"*/}

          {data?.reviewerRemarks &&
            (userDetails.roleId == 3 || userDetails.roleId == 12) && (
              <Grid container spacing={3} style={{ marginTop: "20px" }}>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    disabled
                    label={<span>Reviewer Remark</span>}
                    value={data?.reviewerRemarks || ""}
                  />
                </Grid>
              </Grid>
            )}

          {data?.rejectedRemarks &&
            (userDetails.roleId == 12 || userDetails.roleId == 3) && (
              <Grid container spacing={3} style={{ marginTop: "20px" }}>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    disabled
                    label={<span>IQC Remark</span>}
                    value={data?.rejectedRemarks || ""}
                  />
                </Grid>
              </Grid>
            )}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "25px",
              gap: "20px",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              className="pt-button--primary"
              sx={{ mt: 8 }}
              onClick={handleBack}
            >
              Back
            </Button>
            {userDetails?.roleId !== 12 &&
              data?.toBeCheckedBy !== userDetails.userId && (
                <Button
                  type="submit"
                  variant="contained"
                  className="pt-button--primary"
                  sx={{ mt: 8 }}
                              onClick={handleSubmit}
                              disabled={isSubmitDisabled || (isValidStatus2 && !isSampleGenerated)}
                >
                  Submit
                </Button>
              )}
            {userDetails?.roleId == 12 && (
              <Button
                type="button"
                variant="contained"
                className="pt-button--primary"
                sx={{ mt: 8 }}
                onClick={handleAcknowledge}
                disabled={[
                  "Acknowledged by IQC Engineer",
                  "Approved",
                  //"Rejected,Sent back to Supplier",
                  "Rejected by IQC Engineer,Sent back to Supplier"
                ].includes(data?.statusName)}
              >
                Acknowledge
              </Button>
            )}
            {userDetails?.roleId === 3 &&
              data?.toBeCheckedBy == userDetails.userId && (
                <Button
                  type="button"
                  variant="contained"
                  className="pt-button--primary"
                  sx={{ mt: 8 }}
                  onClick={handleReviewer}
                  disabled={[
                    "Updated by Supplier,Pending at IQC Engineer for Approval",
                    "Acknowledged by IQC Engineer",
                    "Approve",
                    "Rejected by IQC Engineer,Sent back to Supplier",
                    "Rejected by Reviewer, Sent back to Supplier",
                  ].includes(data?.statusName)}
                >
                  Approve
                </Button>
              )}

            {userDetails?.roleId === 3 &&
              data?.toBeCheckedBy == userDetails.userId && (
                <Button
                  type="button"
                  variant="contained"
                  className="pt-button--primary"
                  sx={{ mt: 8 }}
                  onClick={handleDialogOpenReject}
                  disabled={[
                    "Updated by Supplier,Pending at IQC Engineer for Approval",
                    "Acknowledged by IQC Engineer",
                    "Approve",
                    "Rejected by IQC Engineer,Sent back to Supplier",
                    "Rejected by Reviewer, Sent back to Supplier",
                  ].includes(data?.statusName)}
                >
                  Reject
                </Button>
              )}

            <Dialog
              fullWidth
              open={openDialogReject}
              onClose={handleCloseReject}
              aria-labelledby="form-dialog-title"
            >
              <DialogContent>
                <h3 style={{ paddingBottom: "25px" }}>Supplier Comments</h3>
                <Grid>
                  <TextField
                    fullWidth
                    id="standard-multiline-flexible"
                    placeholder="Enter Feedback"
                    variant="outlined"
                    multiline
                    inputProps={{
                      style: {
                        height: "70px",
                      },
                    }}
                    maxRows={5}
                    onChange={getRejectRemarkBySupplier}
                    value={rejectRemarkBySupplier}
                  />
                </Grid>
              </DialogContent>
              <DialogActions>
                <div style={{ display: "flex", gap: "10px" }}>
                  {" "}
                  <Button
                    onClick={handleRejectReviwer}
                    className="pt-button--primary button-submit first-btn"
                    variant="contained"
                    color="primary"
                  >
                    Submit
                  </Button>
                  <Button
                    className="pt-button--secondary button-submit"
                    variant="contained"
                    onClick={handleCloseReject}
                    color="primary"
                  >
                    Cancel
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            {userDetails?.roleId === 3 && (
              <Button
                type="button"
                variant="contained"
                className="pt-button--primary"
                sx={{ mt: 8 }}
                disabled={disabledDraftStatusesForSupplier.includes(
                  data?.statusName
                ) || (isValidStatus2 && !isSampleGenerated) }
                onClick={handleSaveAsDraft}
              >
                Save As Draft
              </Button>
            )}
          </div>
        </div>
      </form>

      <SnackbarCustom
        open={open}
        message={snackMessage}
        alertType={alertType}
        handleClose={handleClose}
        autoHideDuration={3000}
      />
      <AddLineItemDialog
        open={openDialog}
        onClose={() => closeLineItem()}
        formData={{ inspData }}
        userToEdit={{ editUser }}
        fromPage={fromPage}
        inspectionNumberId={inspectionNumberId}
      />

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="responsive-dialog-title">Delete Record</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure to Delete this Record ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDialogRowDelete}
            className="pt-button--primary"
          >
            Ok
          </Button>
          <Button
            onClick={handleCloseDeleteDialog}
            className="pt-button--secondary"
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {isLoader ? <Loading loaderText="Loading...." /> : <></>}
    </Box>
  );
}
